import { ApiError, apiRequest, apiRequestBlob, apiRequestUpload } from '@/lib/api-client'
import type { BaixaManualInput, BaixaManualResultado } from './baixa-manual'
import type {
  ConciliacaoBancariaResultado,
  SaudeConciliacaoBancaria,
  ParametroCobranca,
  MetaInadimplencia,
  MetasDiaVencimento,
  TetoInadimplencia,
  AbrirFechamentoInput,
  ApuracaoResult,
  AssinaturaAcaoPublicaResp,
  AssinaturaAuditEvento,
  AssinaturaModo,
  AssinaturaPublicaSessao,
  AssinaturaSessao,
  AssinaturaSessaoHistoricoItem,
  AssinaturaStatus,
  Associado,
  AssociadoAlterarSituacaoInput,
  AssociadoAlterarSituacaoResp,
  AssociadoInput,
  AssociadoListParams,
  AssociadosAgregados,
  AssociadosSerieNovos,
  AssociadosSerieConsultores,
  VendaAssociado,
  AssociadoUpdateInput,
  Beneficiario,
  BeneficiarioInput,
  BeneficiarioListParams,
  BeneficiarioPatch,
  BeneficiariosAgregados,
  BensAgregados,
  Boleto,
  BoletoAgregados,
  CarteiraAbertaResumo,
  CancelamentoLote,
  CancelamentoLoteInput,
  BoletosMensalidadePorTipo,
  BoletoSeries,
  BoletosPorDia,
  ConsultaVeicularView,
  ContaBancariaInput,
  ContaBancariaView,
  WebhookTokenView,
  ResultadoTesteConexao,
  TestarConexaoBancoInput,
  BoletoListParams,
  BoletoResumoAssociado,
  BoletoPorAssociado,
  BoletoPorAssociadoListParams,
  CargaEntidade,
  CargaEscopo,
  CargaExecucao,
  CargaExecucoesResponse,
  CargaDisparoResult,
  CentroCusto,
  CentroCustoInput,
  CentroCustoListParams,
  CentroCustoPatch,
  PlanoProtecao,
  PlanoProtecaoInput,
  RegraDescontoAcrescimo,
  RegraDescontoAcrescimoFiltro,
  RegraDescontoAcrescimoInput,
  FaixaAcrescimo,
  FaixaAcrescimoFiltro,
  FaixaAcrescimoInput,
  ImpactoFaixa,
  ImpactoDesativacaoPlano,
  MarcoFaixaAcrescimo,
  SimulacaoFaixa,
  SimulacaoFaixaInput,
  ProdutoCatalogo,
  ProdutoCatalogoInput,
  AdicionalCatalogo,
  AdicionalCatalogoInput,
  ConflitoCatalogo,
  LadoConflitoCatalogo,
  PropostaAdesao,
  PropostaAdesaoInput,
  AplicacaoNegociacao,
  LimiteNegociacao,
  PreviaProposta,
  RecomendacaoPlano,
  RecomendacaoPlanoInput,
  PropostaAdesaoAssociadoInput,
  CompartilhamentoInput,
  CompartilhamentoGerado,
  ComparacaoInput,
  EscolherPlanoPublicoInput,
  CompartilhamentoPublicoResumo,
  EscolherPropostaPublicaInput,
  AceitarPropostaResultado,
  AmbienteCobranca,
  ConfirmarFaturaInput,
  AprovarContratoRecorrenteInput,
  ContratoRecorrente,
  ContratoRecorrenteInput,
  ContratoRecorrenteListParams,
  CursorEnvelope,
  EmissaoLote,
  EmissaoLoteItem,
  EmissaoLotePreview,
  EmissaoTesteInput,
  EmissaoTesteResultado,
  CancelamentoBoletoResultado,
  CategoriaBem,
  CategoriaBemInput,
  CarteiraVoluntario,
  CatalogoDominioItem,
  ConsultorResumo,
  DesempenhoConsultor,
  CooperativaResumo,
  CrmAgregadoEtapa,
  CrmEtapa,
  CrmGrupoEtapa,
  CrmMetrics,
  RelatorioCrmResumo,
  RelatorioCrmFunilEtapa,
  RelatorioCrmRankingLinha,
  RelatorioCrmMotivo,
  RelatorioCrmFiltro,
  ParametroCrm,
  CrmTag,
  CrmTagInput,
  CrmTagPatch,
  CrmTagGrupo,
  CrmTagGrupoInput,
  CrmTagGrupoPatch,
  CrmLeadBem,
  RegrasPrecoDoLead,
  CrmLeadBemInput,
  CategoriaBemResumo,
  CrmAtualizarParticipacaoSinistroPctInput,
  CrmAtualizarMedidasInput,
  CrmAtualizarProprietarioInput,
  CrmReconsultaPlaca,
  CrmLeadBemVistoria,
  CrmDecisaoVistoriaInput,
  CrmDevolverFotosInput,
  CrmMotivoReprovacao,
  CrmAnaliseVistoria,
  CrmDevolucaoResultado,
  CrmVistoriaLinkGerado,
  CrmLiberarVistoriaResposta,
  CrmGuiaVistoria,
  CrmVistoriaFoto,
  CrmLeadDocumento,
  PendenciaAceiteLead,
  ChecklistNegociacaoItem,
  ChecklistVistoriaItem,
  ChecklistVistoriaItemInput,
  ChecklistVistoriaItemPatch,
  CrmGeoUpload,
  CrmVistoriaLaudo,
  FormularioCaptacao,
  FormularioCaptacaoComContagem,
  FormularioCaptacaoInput,
  FotoVistoriaBem,
  RenderFormularioCaptacao,
  SubmissaoCaptacaoInput,
  SimulacaoInput,
  SimulacaoResultado,
  RespostaSubmissaoCaptacao,
  CatalogoCaptacaoResposta,
  CatalogoModelosCaptacaoResposta,
CatalogoCombustiveisCaptacaoResposta,
  TipoVeiculoCaptacao,
  EstadoMigracao,
  Evento,
  EventosAgregados,
  FrotaAgregadosPorTipo,
  FrotaSeriesEntradas,
  FundoSaldo,
  FundoMovimento,
  IndicadoresRateio,
  EventoAnaliseInput,
  EventoInput,
  EventoListParams,
  EventoPatch,
  ExtratoAssociado,
  ExtratoComissoes,
  ComissaoStatus,
  ComissaoGestor,
  ComissaoDoLeadResponse,
  DadosPagamentoInput,
  ResultadoLoteItem,
  TituloGeradoResumo,
  Fechamento,
  FechamentoDetalhe,
  Fornecedor,
  FornecedorAnalytics,
  FornecedorDetalhe,
  FornecedorCadastraisInput,
  TrocaDadosBancariosInput,
  TrocaDadosBancariosResposta,
  FornecedorInput,
  FornecedorListParams,
  PaginaFornecedores,
  FornecedorPrazoPagamentoPatch,
  GeracaoCobrancasResult,
  GerarCobrancasReaisInput,
  Lancamento,
  LancamentoListParams,
  LancamentoManualInput,
  Contato,
  ContatoListParams,
  AtividadeLista,
  AtividadeListParams,
  Lead,
  LeadConverterInput,
  LeadConverterResponse,
  LeadDetalhe,
  LeadAlteracoes,
  PedidosArquivamentoDoLead,
  LeadInput,
  LeadInteracao,
  LeadInteracaoInput,
  LeadListParams,
  LeadPatch,
  ArquivarLeadInput,
  MotivoArquivamento,
  PedidoArquivamento,
  TipoCatalogoDominio,
  MinhaMeta,
  MeuPainel,
  MetaGestor,
  CriarMetaInput,
  RankingParceirosGestor,
  ModoCarteira,
  OrdemCompra,
  OrdemCompraInput,
  OrdemCompraListParams,
  PaginaOrdensCompra,
  OrdemCompraVersionInput,
  PagaveisBoleto,
  PaginatedEnvelope,
  Pagamento,
  PagamentoInput,
  ParametroInadimplencia,
  ParametroInadimplenciaInput,
  ParametroRateio,
  ParametroRateioInput,
  ParametroRateioVersao,
  PlanoConta,
  PlanoContaInput,
  PlanoContaListParams,
  PlanoContaPatch,
  RankingParceiro,
  RecebivelAgregados,
  RecebivelListParams,
  RecebivelResumo,
  CancelamentoRecebivelResultado,
  ReconciliacaoDashboard,
  ReconciliacaoEntidade,
  RelatorioAging,
  ReRateioInput,
  AprovarTituloPendenteInput,
  AprovarTituloPendenteLoteItem,
  CandidatasOCDoTitulo,
  VincularTituloAOCInput,
  AprovarTituloPendenteLoteResponse,
  DetalheNFeTitulo,
  ExcecaoConciliacaoPagar,
  ExcecaoListParams,
  ExcecaoListResponse,
  ResolverExcecaoConciliacaoPagarInput,
  PreviewImportacaoExtratoOFX,
  ResultadoCobrancasReais,
  ResultadoImportacaoExtratoOFX,
  SimulacaoRateio,
  SimulacaoRateioInput,
  ReclassificarTitulosInput,
  TituloExcecaoNFAvulsaInput,
  TituloPagar,
  TituloPagarListParams,
  TituloPagarListResponse,
  TitulosAgregados,
  TenantBranding,
  TenantBrandingInput,
  UsuarioCriado,
  UsuarioDetalhe,
  SenhaProvisoriaGerada,
  UsuarioInput,
  UsuarioListParams,
  UsuarioListResponse,
  Veiculo,
  VeiculoInput,
  VeiculoListParams,
  VeiculoUpdateInput,
  VoluntarioResumo,
  ValorReferencia,
  ValorReferenciaCandidato,
  ValorReferenciaModelo,
  ValorReferenciaAno,
  CrmConfirmarValorReferenciaInput,
} from './contracts'

export const MENSAGEM_TELEFONE_DE_USUARIO = 'Use o telefone do cliente.'

/**
 * Gera um Idempotency-Key para escritas financeiras/governadas (spec §6.4).
 * Obrigatório nos POST de propor parâmetros, abrir/fechar fechamento e cobranças.
 */
function idempotencyKey(): string {
  return crypto.randomUUID()
}

/**
 * Monta a query da listagem de OC: tudo igual a `paramsToQuery`, com UMA
 * diferença — vários status viajam como CSV (`status=a,b,c`).
 *
 * `paramsToQuery` chama `String(value)` em cima do array, e `String(['a','b'])`
 * já dá `"a,b"` por acidente do JS. Está escrito à mão aqui de propósito:
 * depender daquele acidente faz o contrato da rota ficar preso a uma coerção
 * implícita, e quem lesse `status?: readonly T[]` não teria como saber que a
 * forma no fio é CSV.
 */
function queryDaListaOC(params?: OrdemCompraListParams): object | undefined {
  if (!params) return undefined
  const { status, ...resto } = params
  if (status === undefined) return resto
  return { ...resto, status: Array.isArray(status) ? status.join(',') : status }
}


function paramsToQuery(params?: object): string {
  if (!params) return ''
  const search = new URLSearchParams()
  Object.entries(params as Record<string, string | number | boolean | null | undefined>).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      search.set(key, String(value))
    }
  })
  const query = search.toString()
  return query ? `?${query}` : ''
}

/**
 * queryLeads traduz os filtros do funil para a query string de
 * `GET /v1/crm/leads` (#1075). Existe por um único ponto de divergência: o
 * backend expõe a presença de atendimento como o tri-estado `sem_atividade`
 * (true = sem, false = com), e `atividade` não é parâmetro de lá — mandar o
 * campo cru viraria filtro ignorado em silêncio.
 *
 * Todo caminho do CRM que lista lead (lista paginada, kanban agrupado, coluna
 * por etapa, agregado da coluna) passa por aqui — senão um filtro valeria na
 * lista e não no total da coluna.
 */
function queryLeads(params?: LeadListParams & { agrupado?: string }): string {
  if (!params) return ''
  const { atividade, ...resto } = params
  return paramsToQuery({
    ...resto,
    sem_atividade: atividade === undefined ? undefined : atividade === 'sem',
  })
}

/**
 * montarFormDataFotoVistoria (Fase 3, guia de fotos de vistoria) — monta o
 * multipart/form-data compartilhado pelos 2 endpoints de upload (consultor e
 * público): campo `foto` (arquivo) + `latitude`/`longitude`/`precisao_metros`
 * OPCIONAIS (geolocalização best-effort — ausência nunca bloqueia o envio,
 * por isso os campos só entram no FormData quando definidos).
 */
function montarFormDataFotoVistoria(arquivo: File, geo: CrmGeoUpload): FormData {
  const form = new FormData()
  form.set('foto', arquivo)
  if (geo.latitude !== undefined) form.set('latitude', String(geo.latitude))
  if (geo.longitude !== undefined) form.set('longitude', String(geo.longitude))
  if (geo.precisao_metros !== undefined) form.set('precisao_metros', String(geo.precisao_metros))
  return form
}

export const domainApi = {
  associados: (params?: AssociadoListParams) =>
    apiRequest<PaginatedEnvelope<Associado>>(`/v1/associados${paramsToQuery(params)}`),
  /** GET /v1/associados/agregados → KPIs de carteira (sem PII; associado:listar). */
  associadosAgregados: (params?: { de?: string; ate?: string }) =>
    apiRequest<AssociadosAgregados>(`/v1/associados/agregados${paramsToQuery(params)}`),
  /** GET /v1/associados/series → série mensal de novos contratos (sem PII; associado:listar). W1-110. */
  associadosSerie: (params?: { ate?: string; meses?: number }) =>
    apiRequest<AssociadosSerieNovos>(`/v1/associados/series${paramsToQuery(params)}`),
  /** GET /v1/associados/series/consultores → venda por consultor na janela (sem PII; associado:listar). #677. */
  associadosSerieConsultores: (params?: { ate?: string; meses?: number }) =>
    apiRequest<AssociadosSerieConsultores>(`/v1/associados/series/consultores${paramsToQuery(params)}`),
  /** GET /v1/associados/{id}/venda → marcos da venda (associado:ver). #677. */
  associadoVenda: (id: string) => apiRequest<VendaAssociado>(`/v1/associados/${id}/venda`),
  associadoDetalhe: (id: string, revelarPII = false) =>
    apiRequest<Associado>(`/v1/associados/${id}${paramsToQuery({ revelar_pii: revelarPII || undefined })}`),
  beneficiarios: (params?: BeneficiarioListParams) =>
    apiRequest<PaginatedEnvelope<Beneficiario>>(`/v1/beneficiarios${paramsToQuery(params)}`),
  beneficiarioDetalhe: (id: string, revelarPII = false) =>
    apiRequest<Beneficiario>(`/v1/beneficiarios/${id}${paramsToQuery({ revelar_pii: revelarPII || undefined })}`),
  /** GET /v1/beneficiarios/agregados → KPIs simples (total/por situação, sem PII; beneficiario:listar). DB-5. */
  beneficiariosAgregados: () => apiRequest<BeneficiariosAgregados>('/v1/beneficiarios/agregados'),

  bens: (params?: VeiculoListParams) =>
    apiRequest<PaginatedEnvelope<Veiculo>>(`/v1/veiculos${paramsToQuery(params)}`),
  /**
   * GET /v1/associados/{id}/bens → bens de UM associado, sob `associado:ver`
   * (A2 da auditoria da matriz, 25/09/2026).
   *
   * Existe porque a carteira inteira (`/v1/veiculos`, `bem:listar`) é uma
   * permissão que o `gestor` não tem por decisão explícita de 02/09 — e a aba
   * Bens da ficha, que chamava a carteira, levava 403 justamente para o perfil
   * que precisava dela para escolher plano. O escopo vem do path: não há
   * parâmetro que amplie o recorte.
   */
  bensDoAssociado: (associadoId: string, params?: { limit?: number }) =>
    apiRequest<PaginatedEnvelope<Veiculo>>(`/v1/associados/${associadoId}/bens${paramsToQuery(params ?? {})}`),
  /** GET /v1/veiculos/agregados → KPIs de carteira de bens (sem PII; bem:listar). */
  bensAgregados: () => apiRequest<BensAgregados>('/v1/veiculos/agregados'),
  /** GET /v1/veiculos/agregados-por-tipo → frota (ativos/total + valor protegido) por tipo (W1-115; bem:listar). */
  veiculosAgregadosPorTipo: () => apiRequest<FrotaAgregadosPorTipo>('/v1/veiculos/agregados-por-tipo'),
  /** GET /v1/veiculos/series-entradas?meses=N → entradas de veículos por mês×tipo (W1-115; bem:listar). Sem `meses` = histórico completo. */
  veiculosSeriesEntradas: (params?: { meses?: number }) =>
    apiRequest<FrotaSeriesEntradas>(`/v1/veiculos/series-entradas${paramsToQuery(params)}`),
  /** GET /v1/veiculos/{id} → Veiculo (detalhe individual; bem:ver). */
  veiculoDetalhe: (id: string) => apiRequest<Veiculo>(`/v1/veiculos/${id}`),
  /** GET /v1/veiculos/{id}/fotos-vistoria → { data: FotoVistoriaBem[] } (bem:ver, SEM checagem cruzada de crm). Reforma da vistoria, Parte C: fatia vazia = bem sem vistoria vinculada (nunca erro). */
  fotosVistoriaBem: (id: string) =>
    apiRequest<{ data: FotoVistoriaBem[] }>(`/v1/veiculos/${id}/fotos-vistoria`),
  /** GET /v1/veiculos/{id}/fotos-vistoria/{fotoId} → Blob (bem:ver). Stream via BFF — nunca URL do storage. */
  baixarFotoVistoriaBemProtegido: (id: string, fotoId: string) =>
    apiRequestBlob(`/v1/veiculos/${id}/fotos-vistoria/${fotoId}`),
  /** `total_estimado` aqui é EXATO até 500; acima disso vira piso e
   *  `total_excede_teto` avisa (#527). Campo só desta listagem — o envelope
   *  genérico não o carrega. */
  boletos: (params?: BoletoListParams) =>
    apiRequest<PaginatedEnvelope<Boleto> & { total_excede_teto?: boolean }>(
      `/v1/boletos${paramsToQuery(params)}`,
    ),
  /** GET /v1/boletos/associado-resumo (FINC-06, financeiro:ver): `associado_id` obrigatório. */
  boletosResumoAssociado: (params: { associado_id: string; bem_id?: string; situacao?: string }) =>
    apiRequest<BoletoResumoAssociado>(`/v1/boletos/associado-resumo${paramsToQuery(params)}`),
  boletosAgregados: (params?: BoletoListParams) =>
    apiRequest<BoletoAgregados>(`/v1/boletos/agregados${paramsToQuery(params)}`),
  /** GET /v1/cobranca/parametro → dias de vencimento do tenant (financeiro:ver). #611.
   *  404 é resposta legítima: tenant sem parâmetro configurado. */
  parametroCobranca: () => apiRequest<ParametroCobranca>('/v1/cobranca/parametro'),
  /** PUT /v1/cobranca/parametro → grava snapshot novo (financeiro:configurar + MFA). #611.
   *  Snapshot completo, não PATCH: o conjunto inteiro é o que fica gravado. */
  salvarParametroCobranca: (dias: number[]) =>
    apiRequest<ParametroCobranca>('/v1/cobranca/parametro', {
      method: 'PUT',
      body: JSON.stringify({ dias_vencimento: dias }),
    }),
  /** GET /v1/receber/inadimplencia/metas/dia-vencimento → alvo × realizado (receber:ver). #611. */
  metasDiaVencimento: (competencia?: string) =>
    apiRequest<MetasDiaVencimento>(
      `/v1/receber/inadimplencia/metas/dia-vencimento${paramsToQuery({ competencia })}`,
    ),
  /**
   * PUT /v1/receber/inadimplencia/metas/dia-vencimento → define o alvo de um
   * dia (receber:re_rateio + MFA). Uma meta por chamada: é como o backend
   * modela (snapshot por recorte, a anterior é desativada, não sobrescrita).
   */
  /** GET /v1/receber/inadimplencia/metas/teto → o teto único (receber:ver). */
  tetoInadimplencia: () =>
    apiRequest<TetoInadimplencia>('/v1/receber/inadimplencia/metas/teto'),
  /** PUT /v1/receber/inadimplencia/metas/teto (receber:re_rateio + MFA). */
  definirTetoInadimplencia: (pctAlvo: number) =>
    apiRequest<MetaInadimplencia>('/v1/receber/inadimplencia/metas/teto', {
      method: 'PUT',
      body: JSON.stringify({ pct_alvo: pctAlvo }),
    }),
  definirMetaDiaVencimento: (dia: number, pctAlvo: number, base: 'valor' | 'associado') =>
    apiRequest<MetaInadimplencia>('/v1/receber/inadimplencia/metas/dia-vencimento', {
      method: 'PUT',
      body: JSON.stringify({ dia_vencimento: dia, pct_alvo: pctAlvo, base }),
    }),
  /** GET /v1/boletos/series → séries mensais (arrecadação/vencimento; sem PII; financeiro:ver). W1-110. */
  boletosSerie: (params?: { ate?: string; meses?: number }) =>
    apiRequest<BoletoSeries>(`/v1/boletos/series${paramsToQuery(params)}`),
  /** GET /v1/boletos/por-dia → previsto × liquidado por vencimento + arrecadação diária (financeiro:ver). Janela ≤ 93 dias. */
  boletosPorDia: (params: { de: string; ate: string }) =>
    apiRequest<BoletosPorDia>(`/v1/boletos/por-dia${paramsToQuery(params)}`),
  /** GET /v1/boletos/mensalidade-por-tipo → mensalidade média por tipo de veículo, janela fixa do backend (W1-115; financeiro:ver). */
  boletosMensalidadePorTipo: () => apiRequest<BoletosMensalidadePorTipo>('/v1/boletos/mensalidade-por-tipo'),
  /** GET /v1/boletos/por-associado → visão primária por associado (financeiro:ver). */
  boletosPorAssociado: (params?: BoletoPorAssociadoListParams) =>
    apiRequest<PaginatedEnvelope<BoletoPorAssociado>>(`/v1/boletos/por-associado${paramsToQuery(params)}`),
  // Rotas LEGADAS removidas do backend (auditoria fake-vs-real, item A):
  // emitirBoleto (POST /v1/boletos) → emissão real é a F2 (emissao-lote);
  // segundaViaBoleto (GET .../segunda-via) → 2ª via real é a F3 (boletoPagaveis/boletoPdf).

  // ─── F3: ver o boleto (dados pagáveis + PDF), atrás da flag bancária ───
  /** GET /v1/financeiro/boletos/{id}/pagaveis → linha/barras/QR (financeiro:ver). 404 = flag OFF. */
  boletoPagaveis: (id: string) =>
    apiRequest<PagaveisBoleto>(`/v1/financeiro/boletos/${id}/pagaveis`),
  /** GET /v1/financeiro/boletos/{id}/pdf → binário do boleto via BFF (nunca credencial no browser). */
  boletoPdf: (id: string) =>
    apiRequestBlob(`/v1/financeiro/boletos/${id}/pdf`),
  /** F3.1: GET /v1/financeiro/boletos/{id}/qrcode.png → imagem do QR Pix gerada no servidor. */
  boletoQrCode: (id: string) =>
    apiRequestBlob(`/v1/financeiro/boletos/${id}/qrcode.png`),

  // ─── F2: emissão manual de boletos em lote por competência (registro no Sicredi) ───
  /** GET /v1/financeiro/emissao-lote/preview?competencia=AAAA-MM → dry-run (pendentes + valor; financeiro:ver). */
  emissaoLotePreview: (competencia: string) =>
    apiRequest<EmissaoLotePreview>(`/v1/financeiro/emissao-lote/preview${paramsToQuery({ competencia })}`),
  /** POST /v1/financeiro/emissao-lote → dispara o lote assíncrono (financeiro:emitir — crítica/MFA). */
  emissaoLoteDisparar: (competencia: string) =>
    apiRequest<EmissaoLote>('/v1/financeiro/emissao-lote', {
      method: 'POST',
      body: JSON.stringify({ competencia }),
    }),
  /** GET /v1/financeiro/emissao-lote/{id} → status/progresso do lote (financeiro:ver). */
  emissaoLoteStatus: (id: string) =>
    apiRequest<EmissaoLote>(`/v1/financeiro/emissao-lote/${id}`),
  /** GET /v1/financeiro/emissao-lote/{id}/itens → resultado por boleto (financeiro:ver). */
  emissaoLoteItens: (id: string) =>
    apiRequest<{ lote_id: string; itens: EmissaoLoteItem[] }>(`/v1/financeiro/emissao-lote/${id}/itens`),
  /** GET /v1/financeiro/emissao-lote → lotes recentes (financeiro:ver). Usado para
   *  retomar o último lote de uma competência ao (re)montar a tela (UX #4). */
  emissaoLoteListar: () =>
    apiRequest<{ lotes: EmissaoLote[] }>('/v1/financeiro/emissao-lote'),
  /** GET /v1/financeiro/ambiente-cobranca → ambiente da conta de cobrança ativa
   *  (financeiro:ver). Fonte do banner de homologação global (UX #7). */
  ambienteCobranca: () =>
    apiRequest<AmbienteCobranca>('/v1/financeiro/ambiente-cobranca'),
  /** POST /v1/financeiro/emissao-teste → emite UM boleto de teste de homologação
   *  (gate do DV; financeiro:emitir — crítica/MFA; só produção). */
  emissaoTeste: (input: EmissaoTesteInput) =>
    apiRequest<EmissaoTesteResultado>('/v1/financeiro/emissao-teste', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** POST /v1/boletos/{id}/cancelar → cancela o boleto (instrução de baixa no
   *  banco + FSM → cancelado; financeiro:cancelar — crítica/MFA; só produção). */
  cancelarBoleto: (id: string, motivo: string) =>
    apiRequest<CancelamentoBoletoResultado>(`/v1/boletos/${id}/cancelar`, {
      method: 'POST',
      body: JSON.stringify({ motivo }),
    }),
  /** POST /v1/boletos/{id}/baixa → baixa MANUAL (financeiro:baixar — crítica/MFA; Idempotency-Key
   *  obrigatória). Com a flag financeiro.baixa_manual.habilitada: forma, data de crédito e
   *  justificativa; o pedido de baixa ao banco volta em `pedido_banco`. */
  efetuarBaixaBoleto: (id: string, chave: string, input: BaixaManualInput) =>
    apiRequest<BaixaManualResultado>(`/v1/boletos/${id}/baixa`, {
      method: 'POST',
      headers: { 'Idempotency-Key': chave },
      body: JSON.stringify(input),
    }),

  // ─── Central de Boletos (docs/design_central_boletos.md) ──────────────────
  /** GET /v1/boletos/carteira-aberta/resumo → carteira em aberto ao vivo,
   *  cache de 60s no servidor (financeiro:ver). */
  boletosCarteiraAbertaResumo: (params?: BoletoListParams) =>
    apiRequest<CarteiraAbertaResumo>(`/v1/boletos/carteira-aberta/resumo${paramsToQuery(params)}`),
  /** POST /v1/boletos/cancelamento-lote → dispara o lote assíncrono
   *  (financeiro:cancelar — crítica/MFA; só produção). 409 se já há lote em
   *  andamento; 422 motivo/lista inválidos (1–500 ids, motivo 1–300). */
  cancelamentoLoteDisparar: (input: CancelamentoLoteInput) =>
    apiRequest<CancelamentoLote>('/v1/boletos/cancelamento-lote', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** GET /v1/boletos/cancelamento-lote/{id} → lote + itens (financeiro:ver). */
  cancelamentoLoteStatus: (id: string) =>
    apiRequest<CancelamentoLote>(`/v1/boletos/cancelamento-lote/${id}`),
  /** POST /v1/boletos/cancelamento-lote/{id}/retomar → retoma itens pendentes
   *  de um lote com heartbeat expirado (financeiro:cancelar — crítica/MFA). */
  cancelamentoLoteRetomar: (id: string) =>
    apiRequest<CancelamentoLote>(`/v1/boletos/cancelamento-lote/${id}/retomar`, {
      method: 'POST',
    }),
  // ─── Rateio: leitura (rateio:ver) ─────────────────────────────────────────
  categoriasRateio: (competencia?: string) =>
    apiRequest<CategoriaBem[]>(`/v1/rateio/categorias${paramsToQuery({ competencia })}`),
  parametrosRateio: (competencia?: string) =>
    apiRequest<ParametroRateio>(`/v1/rateio/parametros${paramsToQuery({ competencia })}`),
  fechamentos: () => apiRequest<PaginatedEnvelope<Fechamento>>('/v1/rateio/fechamentos'),
  fechamentoDetalhe: (competencia: string) =>
    apiRequest<FechamentoDetalhe>(`/v1/rateio/fechamentos/${competencia}`),
  simulacaoRateio: (input: SimulacaoRateioInput) =>
    apiRequest<SimulacaoRateio>('/v1/rateio/simulacao', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** GET /v1/rateio/parametros/pendentes → versões em status "proposto" (maker-checker). */
  listarParametrosPendentes: () => apiRequest<ParametroRateioVersao[]>('/v1/rateio/parametros/pendentes'),

  // ─── Fundo de reserva + indicadores de saúde do rateio (rateio:ver) ─── W1-111
  /** GET /v1/rateio/indicadores → cobertura, uso da proteção, alertas (competencia AAAA-MM obrigatória; sem PII). */
  rateioIndicadores: (competencia: string, limiarSubsidio?: string) =>
    apiRequest<IndicadoresRateio>(
      `/v1/rateio/indicadores${paramsToQuery({ competencia, limiar_subsidio: limiarSubsidio })}`,
    ),
  /** GET /v1/rateio/fundo/saldo → saldo do fundo de reserva (sem PII). */
  fundoSaldo: () => apiRequest<FundoSaldo>('/v1/rateio/fundo/saldo'),
  /** GET /v1/rateio/fundo/movimentos → ledger recente do fundo (envelope { data }, sem PII). */
  fundoMovimentos: (limit?: number) =>
    apiRequest<{ data: FundoMovimento[] }>(`/v1/rateio/fundo/movimentos${paramsToQuery({ limit })}`),

  // ─── Rateio: configuração de categorias (rateio:configurar) ────────────────
  /** POST /v1/rateio/categorias → 201 CategoriaBem. */
  criarCategoriaRateio: (input: CategoriaBemInput) =>
    apiRequest<CategoriaBem>('/v1/rateio/categorias', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** PATCH /v1/rateio/categorias/{id} → 200 CategoriaBem. 409 CONFLICT (version). */
  atualizarCategoriaRateio: (id: string, input: CategoriaBemInput) =>
    apiRequest<CategoriaBem>(`/v1/rateio/categorias/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    }),
  /** DELETE /v1/rateio/categorias/{id} → 204. Body: { version }. */
  inativarCategoriaRateio: (id: string, version: number) =>
    apiRequest<void>(`/v1/rateio/categorias/${id}`, {
      method: 'DELETE',
      body: JSON.stringify({ version }),
    }),

  // ─── Rateio: parâmetros governados (maker-checker, rateio:configurar) ───────
  /** POST /v1/rateio/parametros → 201 versão "proposto" (maker). Idempotency-Key. */
  proporParametrosRateio: (input: ParametroRateioInput) =>
    apiRequest<ParametroRateioVersao>('/v1/rateio/parametros', {
      method: 'POST',
      headers: { 'Idempotency-Key': idempotencyKey() },
      body: JSON.stringify(input),
    }),
  /** POST /v1/rateio/parametros/{versao}/aprovar → 200 (checker ≠ proponente). */
  aprovarParametrosRateio: (versao: number) =>
    apiRequest<ParametroRateioVersao>(`/v1/rateio/parametros/${versao}/aprovar`, {
      method: 'POST',
    }),

  // ─── Rateio: fechamento (rateio:fechar — crítica/MFA) ──────────────────────
  /** POST /v1/rateio/fechamentos → 200 Fechamento (abrir/recalcular, idempotente). Idempotency-Key. */
  abrirFechamento: (input: AbrirFechamentoInput) =>
    apiRequest<Fechamento>('/v1/rateio/fechamentos', {
      method: 'POST',
      headers: { 'Idempotency-Key': idempotencyKey() },
      body: JSON.stringify(input),
    }),
  /** POST /v1/rateio/fechamentos/{competencia}/fechar → 200 (imutável). Idempotency-Key. */
  fecharCompetencia: (competencia: string) =>
    apiRequest<Fechamento>(`/v1/rateio/fechamentos/${competencia}/fechar`, {
      method: 'POST',
      headers: { 'Idempotency-Key': idempotencyKey() },
    }),
  /** POST /v1/rateio/fechamentos/{competencia}/cobrancas → 202 (Fake Paytime). Idempotency-Key. */
  gerarCobrancas: (competencia: string) =>
    apiRequest<GeracaoCobrancasResult>(`/v1/rateio/fechamentos/${competencia}/cobrancas`, {
      method: 'POST',
      headers: { 'Idempotency-Key': idempotencyKey() },
      body: JSON.stringify({}),
    }),

  /** POST /v1/rateio/fechamentos/{competencia}/gerar-cobrancas → 202 (boleto real + recebíveis discriminados). Gatilho GATED: receber:gerar_cobranca (crítica/MFA) + flag rateio.cobranca_real.habilitada. Idempotency-Key. */
  gerarCobrancasReais: (competencia: string, input: GerarCobrancasReaisInput = {}) =>
    apiRequest<ResultadoCobrancasReais>(`/v1/rateio/fechamentos/${competencia}/gerar-cobrancas`, {
      method: 'POST',
      headers: { 'Idempotency-Key': idempotencyKey() },
      body: JSON.stringify(input),
    }),

  // ─── Contas a Receber (FC-3 "Parte A", leitura — receber:ver) ──────────────
  recebiveis: (params?: RecebivelListParams) =>
    apiRequest<PaginatedEnvelope<RecebivelResumo>>(`/v1/receber/recebiveis${paramsToQuery(params)}`),
  /** POST /v1/receber/recebiveis/{id}/cancelar → receber:cancelar (crítica/MFA). 409 CANCELAR_PELO_BOLETO quando há boleto em aberto. */
  cancelarRecebivel: (id: string, version: number, motivo: string) =>
    apiRequest<CancelamentoRecebivelResultado>(`/v1/receber/recebiveis/${id}/cancelar`, {
      method: 'POST',
      body: JSON.stringify({ version, motivo }),
    }),
  recebiveisAgregados: (params?: RecebivelListParams) =>
    apiRequest<RecebivelAgregados>(`/v1/receber/agregados${paramsToQuery(params)}`),
  extratoAssociado: (associadoId: string, referencia?: string) =>
    apiRequest<ExtratoAssociado>(`/v1/receber/associados/${associadoId}/extrato${paramsToQuery({ referencia })}`),

  // ─── Inadimplência (FC-3 Fatia 3 Parte B) ──────────────────────────────────
  /** GET /v1/receber/inadimplencia/aging → buckets de dias em atraso (receber:ver). */
  agingInadimplencia: (referencia?: string) =>
    apiRequest<RelatorioAging>(`/v1/receber/inadimplencia/aging${paramsToQuery({ referencia })}`),
  /** POST /v1/receber/inadimplencia/re-rateio/simular → dry-run, nunca persiste (receber:simular, não crítica). */
  simularReRateio: (input: ReRateioInput) =>
    apiRequest<ApuracaoResult>('/v1/receber/inadimplencia/re-rateio/simular', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** GET /v1/receber/inadimplencia/parametro → config vigente (singleton, receber:ver). */
  parametroInadimplencia: () =>
    apiRequest<ParametroInadimplencia>('/v1/receber/inadimplencia/parametro'),
  /**
   * PUT /v1/receber/inadimplencia/parametro → grava SNAPSHOT completo
   * (não é PATCH — reenviar todos os campos). Gated receber:re_rateio +
   * MFA/aal2 (toca elegibilidade de auxílio). 200 com o parâmetro salvo.
   */
  atualizarParametroInadimplencia: (input: ParametroInadimplenciaInput) =>
    apiRequest<ParametroInadimplencia>('/v1/receber/inadimplencia/parametro', {
      method: 'PUT',
      body: JSON.stringify(input),
    }),

  /**
   * GET /readyz → readiness público da API. 200 {status:"ready"} = API+deps
   * de pé; 503 (via nginx/proxy quando a API interna cai) faz apiRequest
   * lançar ApiError → a aba Integrações trata como "indisponível". Sem PII.
   */
  readyz: () => apiRequest<{ status: string }>('/readyz'),

  estadoMigracao: () => apiRequest<EstadoMigracao>('/v1/migracao/estado'),

  // ─── Conciliação / disparo de carga sob demanda (cargaexec, W1-64 Fase B) ──
  /**
   * POST /v1/admin/carga/{entidade} → 202 (carga:disparar — crítica/MFA).
   * Sem `escopo`, dispara carga FULL — usado por associado/veiculo/
   * beneficiario/evento. `boleto` (W1-66) é a exceção: exige sempre
   * `escopo.competencia_de/ate` (janela de vencimento obrigatória, ver
   * BoletoRangeSelector) — nunca dispara full.
   */
  dispararCarga: (entidade: CargaEntidade, escopo?: CargaEscopo) =>
    apiRequest<CargaDisparoResult>(`/v1/admin/carga/${entidade}`, {
      method: 'POST',
      body: JSON.stringify(escopo ? { escopo } : {}),
    }),
  /** GET /v1/admin/carga/{entidade}/{id} → status/relatório de uma execução (carga:ver_status). */
  statusCarga: (entidade: CargaEntidade, id: string) =>
    apiRequest<CargaExecucao>(`/v1/admin/carga/${entidade}/${id}`),
  /** GET /v1/admin/carga/{entidade} → execuções recentes, mais nova primeiro (carga:ver_status). */
  execucoesRecentesCarga: (entidade: CargaEntidade, limite?: number) =>
    apiRequest<CargaExecucoesResponse>(`/v1/admin/carga/${entidade}${paramsToQuery({ limite })}`),

  // ─── Reconciliação / certificação (W1-02/W1-03, mesma permissão carga:ver_status) ──
  /** GET /v1/admin/reconciliacao/{entidade} → dashboard de drift PPM×SGA e streak de certificação. */
  reconciliacaoDashboard: (entidade: ReconciliacaoEntidade, limite?: number) =>
    apiRequest<ReconciliacaoDashboard>(`/v1/admin/reconciliacao/${entidade}${paramsToQuery({ limite })}`),

  // ─── Escritas: Associado ──────────────────────────────────────────────────
  /** POST /v1/associados → 201 Associado. 409 CPF_DUPLICADO / CONFLICT. 422 VALIDATION_ERROR */
  criarAssociado: (input: AssociadoInput) =>
    apiRequest<Associado>('/v1/associados', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** PATCH /v1/associados/{id} → 200 Associado. 409 CONFLICT (version stale). */
  atualizarAssociado: (id: string, input: AssociadoUpdateInput) =>
    apiRequest<Associado>(`/v1/associados/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    }),
  /**
   * POST /v1/associados/{id}/situacao → 200 { associado, historico }
   * (associado:alterar_situacao). 422 TRANSICAO_INVALIDA (FSM recusou —
   * domain.go é a fonte de verdade), 409 CONFLICT (version divergente), 404.
   */
  associadoAlterarSituacao: (id: string, input: AssociadoAlterarSituacaoInput) =>
    apiRequest<AssociadoAlterarSituacaoResp>(`/v1/associados/${id}/situacao`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  // ─── Escritas: Beneficiário (W1-60) ───────────────────────────────────────
  /** POST /v1/beneficiarios → 201 Beneficiario. 409 CPF_DUPLICADO. 422 VALIDATION_ERROR. */
  criarBeneficiario: (input: BeneficiarioInput) =>
    apiRequest<Beneficiario>('/v1/beneficiarios', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** PATCH /v1/beneficiarios/{id} → 200 Beneficiario. 409 CONFLITO_VERSAO (version stale). */
  atualizarBeneficiario: (id: string, input: BeneficiarioPatch) =>
    apiRequest<Beneficiario>(`/v1/beneficiarios/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    }),

  // ─── Escritas: Veículo/Bem ────────────────────────────────────────────────
  /** POST /v1/veiculos → 201 Veiculo. Dinheiro em centavos inteiros. */
  criarVeiculo: (input: VeiculoInput) =>
    apiRequest<Veiculo>('/v1/veiculos', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** PATCH /v1/veiculos/{id} → 200 Veiculo. 409 CONFLICT (version stale). */
  atualizarVeiculo: (id: string, input: VeiculoUpdateInput) =>
    apiRequest<Veiculo>(`/v1/veiculos/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    }),
  /** PUT /v1/veiculos/{id}/valor-referencia → 200 Veiculo. Só para bem sem código e sem valor (409 se já tiver). */
  vincularValorReferenciaVeiculo: (
    id: string,
    input: { codigo_fipe: string; chave_ano: string; valor_centavos: number; mes_referencia: string; consultado_em: string; fonte: string; version: number },
  ) =>
    apiRequest<Veiculo>(`/v1/veiculos/${id}/valor-referencia`, {
      method: 'PUT',
      body: JSON.stringify(input),
    }),

  // ─── Admin de Usuários / RBAC (W1-53) ───────────────────────────────────────
  usuarios: (params?: UsuarioListParams) =>
    apiRequest<UsuarioListResponse>(`/v1/usuarios${paramsToQuery(params)}`),
  usuarioDetalhe: (id: string, revelarPII = false) =>
    apiRequest<UsuarioDetalhe>(`/v1/usuarios/${id}${paramsToQuery({ revelar_pii: revelarPII || undefined })}`),
  criarUsuario: (input: UsuarioInput) =>
    apiRequest<UsuarioCriado>('/v1/usuarios', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  concluirSenhaDefinida: () =>
    apiRequest<void>('/v1/me/senha-definida', { method: 'POST', skipAuthRedirect: true }),
  gerarSenhaProvisoria: (id: string) =>
    apiRequest<SenhaProvisoriaGerada>(`/v1/usuarios/${id}/senha-provisoria`, { method: 'POST' }),
  atribuirPerfil: (id: string, perfil: string) =>
    apiRequest<void>(`/v1/usuarios/${id}/perfis`, {
      method: 'POST',
      body: JSON.stringify({ perfil }),
    }),
  revogarPerfil: (id: string, perfil: string) =>
    apiRequest<void>(`/v1/usuarios/${id}/perfis/${encodeURIComponent(perfil)}`, {
      method: 'DELETE',
    }),
  definirStatusUsuario: (id: string, ativo: boolean, version: number) =>
    apiRequest<UsuarioDetalhe>(`/v1/usuarios/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ ativo, version }),
    }),

  // ─── Eventos / Ocorrências (W1-59) ──────────────────────────────────────────
  /** GET /v1/eventos → listagem paginada por cursor (evento:listar). */
  eventos: (params?: EventoListParams) =>
    apiRequest<PaginatedEnvelope<Evento>>(`/v1/eventos${paramsToQuery(params)}`),
  /** GET /v1/eventos/{id} → detalhe completo (evento:ver). */
  eventoDetalhe: (id: string) =>
    apiRequest<Evento>(`/v1/eventos/${id}`),
  /** POST /v1/eventos → 201 Evento. Requer evento:criar. */
  criarEvento: (input: EventoInput) =>
    apiRequest<Evento>('/v1/eventos', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** PATCH /v1/eventos/{id} → 200 Evento. Optimistic locking via version. Requer evento:editar. */
  atualizarEvento: (id: string, input: EventoPatch) =>
    apiRequest<Evento>(`/v1/eventos/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    }),
  /**
   * POST /v1/eventos/{id}/analise → 200 Evento.
   * Avanço de etapa e decisões (deferir/indeferir).
   * Decisões exigem MFA (aal2) no backend; 403 MFA_REQUERIDA sem step-up.
   * Requer evento:analisar.
   */
  analisarEvento: (id: string, input: EventoAnaliseInput) =>
    apiRequest<Evento>(`/v1/eventos/${id}/analise`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** GET /v1/eventos/agregados → uso da proteção: total/12m + por tipo de veículo × motivo (W1-115; evento:listar). */
  eventosAgregados: () => apiRequest<EventosAgregados>('/v1/eventos/agregados'),

  // ─── CRM de aquisição (funil de vendas) — PR-CRM-2 ────────────────────────
  /** GET /v1/crm/leads → lista paginada por cursor (crm:listar; escopo consultor no backend). */
  crmLeads: (params?: LeadListParams) =>
    apiRequest<PaginatedEnvelope<Lead>>(`/v1/crm/leads${queryLeads(params)}`),
  /** GET /v1/crm/contatos → lista pessoa-cêntrica (dedup) paginada por cursor opaco (crm:listar). */
  crmContatos: (params?: ContatoListParams) =>
    apiRequest<PaginatedEnvelope<Contato>>(`/v1/crm/contatos${paramsToQuery(params)}`),
  /** GET /v1/crm/contatos/{chave}/negociacoes → as N negociações da pessoa (crm:ver; CPF mascarado). */
  crmContatoNegociacoes: (chave: string) =>
    apiRequest<{ data: Lead[] }>(`/v1/crm/contatos/${encodeURIComponent(chave)}/negociacoes`),
  /**
   * GET /v1/crm/atividades → agenda global de tarefas (interações com
   * vencimento), escopada pelo dono do lead no backend (crm:listar). Segmento
   * por data BRT (atrasadas/para_hoje/planejadas/concluidas) ou janela de/ate
   * para o calendário. Keyset (cursor opaco, sem offset).
   */
  crmAtividades: (params?: AtividadeListParams) =>
    apiRequest<AtividadeLista>(`/v1/crm/atividades${paramsToQuery(params)}`),
  /** PATCH /v1/crm/atividades/{id} {concluida} → concluir/reabrir tarefa (crm:editar; escopo do dono). */
  concluirAtividade: (id: string, concluida: boolean) =>
    apiRequest<LeadInteracao>(`/v1/crm/atividades/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ concluida }),
    }),
  /** GET /v1/tenant/branding → kit de marca do tenant (ExigirAutenticado, universal). */
  tenantBranding: () => apiRequest<TenantBranding>('/v1/tenant/branding'),
  /** PUT /v1/tenant/branding → atualiza config/paleta/textos (tenant:gerenciar; gates ARGOS+contraste no backend). */
  atualizarTenantBranding: (input: TenantBrandingInput) =>
    apiRequest<TenantBranding>('/v1/tenant/branding', {
      method: 'PUT',
      body: JSON.stringify(input),
    }),
  /** GET /v1/crm/leads?agrupado=etapa → kanban (leads agrupados por etapa). */
  crmLeadsAgrupado: (params?: Omit<LeadListParams, 'cursor' | 'perPage'>) =>
    apiRequest<{ data: { grupos: CrmGrupoEtapa[]; perdidos_sem_origem: number }; truncado: boolean }>(
      `/v1/crm/leads${queryLeads({ ...params, agrupado: 'etapa' })}`,
    ),
  /** GET /v1/crm/leads?etapa=X&cursor=Y — paginação por etapa (Kanban, scroll infinito). */
  crmLeadsPorEtapa: (etapa: string, params: Omit<LeadListParams, 'cursor' | 'perPage' | 'etapa'> & { cursor?: string }) =>
    apiRequest<{ data: Lead[]; next_cursor: string | null }>(
      `/v1/crm/leads${queryLeads({ ...params, etapa, perPage: 20 })}`,
    ),
  /** GET /v1/crm/leads/etapa/{etapa}/agregado — total + soma do valor da coluna, respeitando filtros. */
  crmAgregadoPorEtapa: (etapa: string, params?: Omit<LeadListParams, 'cursor' | 'perPage' | 'etapa'>) =>
    apiRequest<CrmAgregadoEtapa>(
      `/v1/crm/leads/etapa/${etapa}/agregado${queryLeads({ ...params })}`,
    ),
  /** GET /v1/crm/leads/{id} → detalhe + timeline (crm:ver). */
  crmLeadDetalhe: (id: string, revelarPII = false) =>
    apiRequest<LeadDetalhe>(`/v1/crm/leads/${id}${paramsToQuery({ revelar_pii: revelarPII || undefined })}`),
  /** GET /v1/crm/leads/{id}/alteracoes → histórico campo a campo (#886 PR B; crm:ver + dono do lead). ?revelar_pii=true só surte efeito com crm:ver_pii + MFA, auditado. */
  crmLeadAlteracoes: (id: string, revelarPII = false) =>
    apiRequest<LeadAlteracoes>(`/v1/crm/leads/${id}/alteracoes${paramsToQuery({ revelar_pii: revelarPII || undefined })}`),
  /** GET /v1/crm/leads/{id}/pedidos-arquivamento → pedidos do lead para a linha do tempo (crm:ver + escopo do lead). */
  crmLeadPedidosArquivamento: (id: string) =>
    apiRequest<PedidosArquivamentoDoLead>(`/v1/crm/leads/${id}/pedidos-arquivamento`),
  /** GET /v1/crm/leads/{id}/comissao → comissão(ões) de parceiro geradas
   * pela indicação deste lead (crm:ver + dono do lead — 404 pra quem não
   * tem escopo). Card "Comissão" na ficha do lead. */
  crmComissaoDoLead: (id: string) =>
    apiRequest<ComissaoDoLeadResponse>(`/v1/crm/leads/${id}/comissao`),
  /** POST /v1/crm/leads → 201 Lead (crm:criar). Idempotency-Key. */
  criarLead: (input: LeadInput) =>
    apiRequest<Lead>('/v1/crm/leads', {
      method: 'POST',
      headers: { 'Idempotency-Key': idempotencyKey() },
      body: JSON.stringify(input),
    }),
  /** POST /v1/crm/leads/do-simulador → 201 Lead em "novo", com quem criou como dono e o endereço pendente (crm:criar). */
  criarLeadDoSimulador: (input: { nome: string; celular: string; cidade: string; estado: string; bem_interesse?: string; valor_estimado_centavos?: number }) =>
    apiRequest<Lead>('/v1/crm/leads/do-simulador', {
      method: 'POST',
      headers: { 'Idempotency-Key': idempotencyKey() },
      body: JSON.stringify(input),
    }).catch((e: unknown) => {
      if (e instanceof ApiError && e.code === 'TELEFONE_DE_USUARIO') {
        throw new ApiError(e.status, e.code, MENSAGEM_TELEFONE_DE_USUARIO, e.traceId)
      }
      throw e
    }),
  /** PATCH /v1/crm/leads/{id} → 200 Lead. Optimistic lock (version); mover etapa. Requer crm:editar. */
  atualizarLead: (id: string, input: LeadPatch) =>
    apiRequest<Lead>(`/v1/crm/leads/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    }),
  /** POST /v1/crm/leads/{id}/interacoes → 201 LeadInteracao (crm:editar). */
  adicionarInteracaoLead: (id: string, input: LeadInteracaoInput) =>
    apiRequest<LeadInteracao>(`/v1/crm/leads/${id}/interacoes`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /**
   * POST /v1/crm/leads/{id}/converter → cria associado PPM-native + vincula o
   * lead (atômico + idempotente). Requer crm:editar + associado:criar.
   * Idempotency-Key protege replay HTTP; 200 (idempotente) ou 201 (novo).
   */
  converterLead: (id: string, input: LeadConverterInput) =>
    apiRequest<LeadConverterResponse>(`/v1/crm/leads/${id}/converter`, {
      method: 'POST',
      headers: { 'Idempotency-Key': idempotencyKey() },
      body: JSON.stringify(input),
    }),
  /** GET /v1/crm/motivos-arquivamento → motivos ativos (crm:ver). */
  crmMotivosArquivamento: () => apiRequest<{ data: MotivoArquivamento[] }>('/v1/crm/motivos-arquivamento'),
  /** POST /v1/crm/leads/{id}/arquivar → 200 Lead (crm:arquivar). 409 LEAD_ARQUIVADO/LEAD_ENCERRADO. */
  arquivarLead: (id: string, input: ArquivarLeadInput & { version: number }) =>
    apiRequest<Lead>(`/v1/crm/leads/${id}/arquivar`, { method: 'POST', body: JSON.stringify(input) }),
  /** POST /v1/crm/leads/{id}/desarquivar → 200 Lead (crm:arquivar). */
  desarquivarLead: (id: string, version: number) =>
    apiRequest<Lead>(`/v1/crm/leads/${id}/desarquivar`, { method: 'POST', body: JSON.stringify({ version }) }),
  /** POST /v1/crm/leads/{id}/pedido-arquivamento → 201 (crm:editar, escopo do dono). */
  pedirArquivamentoLead: (id: string, input: ArquivarLeadInput) =>
    apiRequest<PedidoArquivamento>(`/v1/crm/leads/${id}/pedido-arquivamento`, { method: 'POST', body: JSON.stringify(input) }),
  /** POST …/pedido-arquivamento/aprovar → 200 Lead (crm:arquivar). */
  aprovarPedidoArquivamento: (id: string, version: number) =>
    apiRequest<Lead>(`/v1/crm/leads/${id}/pedido-arquivamento/aprovar`, { method: 'POST', body: JSON.stringify({ version }) }),
  /** POST …/pedido-arquivamento/recusar → 200 (crm:arquivar). Justificativa obrigatória. */
  recusarPedidoArquivamento: (id: string, justificativa: string) =>
    apiRequest<PedidoArquivamento>(`/v1/crm/leads/${id}/pedido-arquivamento/recusar`, { method: 'POST', body: JSON.stringify({ justificativa }) }),
  /** GET /v1/crm/metrics → agregados do funil (crm:ver; escopo consultor no backend). */
  crmMetrics: () => apiRequest<CrmMetrics>('/v1/crm/metrics'),
  /** GET /v1/crm/etapas → catálogo ordenado das colunas do kanban (crm:ver). */
  crmEtapas: () => apiRequest<{ data: CrmEtapa[] }>('/v1/crm/etapas'),
  /**
   * GET /v1/crm/consultores → candidatos a "dono do lead" pro seletor de
   * filtro (W1-105). Requer crm:gerenciar — 403 pra quem só tem crm:listar
   * (esse escopo já vê só os próprios leads).
   */
  crmConsultores: () => apiRequest<{ data: ConsultorResumo[] }>('/v1/crm/consultores'),
  /**
   * GET /v1/catalogo-dominio?tipo= → listas de domínio que crescem sem deploy
   * (grau de risco, profissão). Requer catalogo_dominio:ver — recurso próprio,
   * não o `catalogo` comercial (#890).
   */
  catalogoDominio: (tipo: TipoCatalogoDominio, incluirInativos = false) =>
    apiRequest<{ data: CatalogoDominioItem[] }>(`/v1/catalogo-dominio${paramsToQuery({ tipo, incluir_inativos: incluirInativos || undefined })}`),
  /** POST /v1/catalogo-dominio → 201 (catalogo_dominio:gerenciar, MFA). Código vazio é gerado da descrição. #890 02b. */
  criarItemCatalogoDominio: (input: { tipo: TipoCatalogoDominio; descricao: string; codigo?: string; ordem: number }) =>
    apiRequest<CatalogoDominioItem>('/v1/catalogo-dominio', { method: 'POST', body: JSON.stringify(input) }),
  /** PATCH /v1/catalogo-dominio/{tipo}/{codigo} → edição parcial (catalogo_dominio:gerenciar, MFA). #890 02b. */
  atualizarItemCatalogoDominio: (tipo: string, codigo: string, input: { descricao?: string; ordem?: number; ativo?: boolean }) =>
    apiRequest<CatalogoDominioItem>(`/v1/catalogo-dominio/${encodeURIComponent(tipo)}/${encodeURIComponent(codigo)}`, { method: 'PATCH', body: JSON.stringify(input) }),
  /**
   * GET /v1/crm/metrics/consultores → tabela agregada por consultor (#328,
   * aba Desempenho): total/conversões/taxa de conversão/valor médio +
   * tendência mensal (sparkline). Requer crm:gerenciar (mesmo gate de
   * /consultores e /parceiros, checado dentro do handler).
   */
  crmDesempenhoConsultores: () => apiRequest<{ data: DesempenhoConsultor[] }>('/v1/crm/metrics/consultores'),
  // ─── Relatórios/BI do CRM (read-only, gated relatorio:ver) ──────────────────
  /** GET /v1/relatorios/crm/resumo → KPIs + por canal + por origem. */
  relatorioCrmResumo: (f?: RelatorioCrmFiltro) =>
    apiRequest<RelatorioCrmResumo>(`/v1/relatorios/crm/resumo${paramsToQuery(f)}`),
  /** GET /v1/relatorios/crm/funil → { etapas } (por etapa + taxa %). */
  relatorioCrmFunil: (f?: RelatorioCrmFiltro) =>
    apiRequest<{ etapas: RelatorioCrmFunilEtapa[] }>(`/v1/relatorios/crm/funil${paramsToQuery(f)}`),
  /** GET /v1/relatorios/crm/ranking → { consultores, limite_arquivamento_pct } (leads/conversão/receita de adesão/arquivados). */
  relatorioCrmRanking: (f?: RelatorioCrmFiltro) =>
    apiRequest<{ consultores: RelatorioCrmRankingLinha[]; limite_arquivamento_pct: number }>(`/v1/relatorios/crm/ranking${paramsToQuery(f)}`),
  /** GET /v1/relatorios/crm/motivos-perda → { motivos } (contagem por motivo). */
  relatorioCrmMotivos: (f?: RelatorioCrmFiltro) =>
    apiRequest<{ motivos: RelatorioCrmMotivo[] }>(`/v1/relatorios/crm/motivos-perda${paramsToQuery(f)}`),
  // ─── Parâmetro do CRM — limite de arquivamento por consultor ────────────────
  /** GET /v1/crm/parametros → limite vigente (crm:ver). padrao=true = sem linha gravada, usa 30%. */
  crmParametros: () => apiRequest<ParametroCrm>('/v1/crm/parametros'),
  /** PUT /v1/crm/parametros → novo limite 0–100 inteiro (crm:configurar, ação crítica MFA). */
  atualizarCrmParametros: (input: { limite_arquivamento_pct: number }) =>
    apiRequest<ParametroCrm>('/v1/crm/parametros', { method: 'PUT', body: JSON.stringify(input) }),
  /** GET /v1/crm/parametros/historico → { itens } (mais recente primeiro, crm:ver). */
  historicoCrmParametros: () => apiRequest<{ itens: ParametroCrm[] }>('/v1/crm/parametros/historico'),
  /** GET /v1/crm/meu-ranking → posição do parceiro logado entre os parceiros ativos (#231). */
  crmMeuRanking: () => apiRequest<RankingParceiro>('/v1/crm/meu-ranking'),
  /** GET /v1/crm/meu-painel → vendas, comissão do mês e extrato pela Rede (voluntario:ver). */
  crmMeuPainel: () => apiRequest<MeuPainel>('/v1/crm/meu-painel'),
  /** GET /v1/crm/tags → catálogo curado (crm:ver). ?somente_ativas=true filtra desativadas. */
  crmTags: (somenteAtivas?: boolean) =>
    apiRequest<{ data: CrmTag[] }>(`/v1/crm/tags${paramsToQuery(somenteAtivas ? { somente_ativas: true } : undefined)}`),
  /** POST /v1/crm/tags → 201 CrmTag (crm:gerenciar). 409 nome duplicado. */
  criarCrmTag: (input: CrmTagInput) =>
    apiRequest<CrmTag>('/v1/crm/tags', { method: 'POST', body: JSON.stringify(input) }),
  /** PATCH /v1/crm/tags/{id} → 200 CrmTag (crm:gerenciar). PATCH parcial. */
  atualizarCrmTag: (id: string, patch: CrmTagPatch) =>
    apiRequest<CrmTag>(`/v1/crm/tags/${id}`, { method: 'PATCH', body: JSON.stringify(patch) }),
  /** POST /v1/crm/leads/{id}/tags → 200 { data: CrmTag[] } — tags do lead após atribuir (crm:editar). */
  atribuirTagAoLead: (leadId: string, tagId: string) =>
    apiRequest<{ data: CrmTag[] }>(`/v1/crm/leads/${leadId}/tags`, {
      method: 'POST',
      body: JSON.stringify({ tag_id: tagId }),
    }),
  /** DELETE /v1/crm/leads/{id}/tags/{tag_id} → 200 { data: CrmTag[] } — tags do lead após remover (crm:editar). */
  removerTagDoLead: (leadId: string, tagId: string) =>
    apiRequest<{ data: CrmTag[] }>(`/v1/crm/leads/${leadId}/tags/${tagId}`, { method: 'DELETE' }),
  /** GET /v1/crm/tag-grupos → categorias do catálogo de tags (crm:ver). ?somente_ativos=true filtra desativados. */
  crmTagGrupos: (somenteAtivos?: boolean) =>
    apiRequest<{ data: CrmTagGrupo[] }>(`/v1/crm/tag-grupos${paramsToQuery(somenteAtivos ? { somente_ativos: true } : undefined)}`),
  /** POST /v1/crm/tag-grupos → 201 CrmTagGrupo (crm:gerenciar). 409 nome duplicado. */
  criarCrmTagGrupo: (input: CrmTagGrupoInput) =>
    apiRequest<CrmTagGrupo>('/v1/crm/tag-grupos', { method: 'POST', body: JSON.stringify(input) }),
  /** PATCH /v1/crm/tag-grupos/{id} → 200 CrmTagGrupo (crm:gerenciar). PATCH parcial. */
  atualizarCrmTagGrupo: (id: string, patch: CrmTagGrupoPatch) =>
    apiRequest<CrmTagGrupo>(`/v1/crm/tag-grupos/${id}`, { method: 'PATCH', body: JSON.stringify(patch) }),

  // ─── Bens/veículos do lead (mig 000091, Fase 1 multi-veículo) ──────────────
  /** GET /v1/crm/categorias-bem → { data: CategoriaBemResumo[] } (crm:ver) — seletor de categoria do bem. */
  listarCategoriasBem: () =>
    apiRequest<{ data: CategoriaBemResumo[] }>(`/v1/crm/categorias-bem`),
  /** GET /v1/crm/leads/{id}/bens → { data: CrmLeadBem[] } (crm:editar + escopo do consultor). */
  crmBensDoLead: (leadId: string) =>
    apiRequest<{ data: CrmLeadBem[] }>(`/v1/crm/leads/${leadId}/bens`),
  /** GET /v1/crm/leads/{id}/regras-preco (crm:ver). 503 quando a porta de regras está indisponível. */
  crmRegrasPrecoDoLead: (leadId: string) =>
    apiRequest<RegrasPrecoDoLead>(`/v1/crm/leads/${leadId}/regras-preco`),
  /** POST /v1/crm/leads/{id}/bens → 201 CrmLeadBem (crm:editar + escopo do consultor). */
  adicionarBemAoLead: (leadId: string, input: CrmLeadBemInput) =>
    apiRequest<CrmLeadBem>(`/v1/crm/leads/${leadId}/bens`, { method: 'POST', body: JSON.stringify(input) }),
  /** DELETE /v1/crm/leads/{id}/bens/{bemId} → 204 (crm:editar + escopo do consultor). */
  removerBemDoLead: (leadId: string, bemId: string) =>
    apiRequest<void>(`/v1/crm/leads/${leadId}/bens/${bemId}`, { method: 'DELETE' }),
  /**
   * PATCH /v1/crm/leads/{id}/bens/{bemId} → 200 CrmLeadBem (crm:editar +
   * escopo do consultor). Único campo editável do bem hoje: percentual de
   * participação em sinistro (franquia, % da FIPE) — mig 000117.
   */
  atualizarParticipacaoSinistroPctDoBem: (leadId: string, bemId: string, input: CrmAtualizarParticipacaoSinistroPctInput) =>
    apiRequest<CrmLeadBem>(`/v1/crm/leads/${leadId}/bens/${bemId}`, { method: 'PATCH', body: JSON.stringify(input) }),

  /**
   * PATCH /v1/crm/leads/{id}/bens/{bemId}/proprietario → 200 CrmLeadBem (crm:editar
   * + escopo). Troca o proprietário do veículo (FINC-10); 422 com documento
   * inválido ou nome ausente quando `eh_associado` é false; 409 em versão velha.
   */
  atualizarProprietarioDoBem: (leadId: string, bemId: string, input: CrmAtualizarProprietarioInput) =>
    apiRequest<CrmLeadBem>(`/v1/crm/leads/${leadId}/bens/${bemId}/proprietario`, { method: 'PATCH', body: JSON.stringify(input) }),
  /**
   * GET /v1/crm/leads/{id}/bens?revelar_pii=true → { data: CrmLeadBem[] } com o
   * `proprietario.documento` completo. Só vale com crm:ver_pii + MFA (sem eles o
   * servidor ignora o parâmetro e devolve mascarado); cada chamada é auditada.
   */
  listarBensDoLeadRevelandoPii: (leadId: string) =>
    apiRequest<{ data: CrmLeadBem[] }>(`/v1/crm/leads/${leadId}/bens${paramsToQuery({ revelar_pii: 'true' })}`),

  /** PATCH /v1/crm/leads/{id}/bens/{bemId}/medidas → 200 CrmLeadBem (crm:editar). */
  atualizarMedidasDoBem: (leadId: string, bemId: string, input: CrmAtualizarMedidasInput) =>
    apiRequest<CrmLeadBem>(`/v1/crm/leads/${leadId}/bens/${bemId}/medidas`, { method: 'PATCH', body: JSON.stringify(input) }),
  /** POST /v1/crm/leads/{id}/bens/{bemId}/reconsultar-placa → 200 (crm:editar + crm:reconsultar_placa). Gasta crédito da Exato fora do cache. */
  reconsultarPlacaDoBem: (leadId: string, bemId: string, aplicarExato = false) =>
    apiRequest<CrmReconsultaPlaca>(
      `/v1/crm/leads/${leadId}/bens/${bemId}/reconsultar-placa${paramsToQuery({ aplicar: aplicarExato ? 'exato' : undefined })}`,
      { method: 'POST' },
    ),

  /** PUT /v1/crm/leads/{id}/bens/{bemId}/valor-referencia → 200 CrmLeadBem (crm:editar + escopo). */
  confirmarValorReferenciaDoBem: (leadId: string, bemId: string, input: CrmConfirmarValorReferenciaInput) =>
    apiRequest<CrmLeadBem>(`/v1/crm/leads/${leadId}/bens/${bemId}/valor-referencia`, { method: 'PUT', body: JSON.stringify(input) }),

  /** POST /v1/crm/leads/{id}/bens/{bemId}/fipe/tentar → 200 CrmLeadBem; 409 VARIAS_VERSOES (versoes); 503 FIPE_INDISPONIVEL. */
  tentarFipeDoBem: (leadId: string, bemId: string, chaveAno?: string) =>
    apiRequest<CrmLeadBem>(`/v1/crm/leads/${leadId}/bens/${bemId}/fipe/tentar`, {
      method: 'POST',
      body: JSON.stringify(chaveAno ? { chave_ano: chaveAno } : {}),
    }),

  /** POST /v1/crm/leads/{id}/bens/{bemId}/consultar-placa → 200 CrmLeadBem (crm:editar); 409 CONSULTA_DESLIGADA|CONSULTA_EM_ANDAMENTO|LEAD_ENCERRADO|LEAD_ARQUIVADO; 422; 502; 503 EXATO_CREDENCIAL_RECUSADA. */
  consultarPlacaBemLead: (leadId: string, bemId: string) =>
    apiRequest<CrmLeadBem>(`/v1/crm/leads/${leadId}/bens/${bemId}/consultar-placa`, { method: 'POST' }),

  /**
   * PUT /v1/crm/leads/{id}/bens/{bemId}/valor-referencia/manual → 200 (crm:gerenciar).
   * O servidor consulta a tabela antes: 409 TABELA_RESPONDEU quando ela encontra o veículo.
   */
  informarValorManualDoBem: (leadId: string, bemId: string, input: { valor_centavos: number; justificativa: string; version: number }) =>
    apiRequest<CrmLeadBem>(`/v1/crm/leads/${leadId}/bens/${bemId}/valor-referencia/manual`, { method: 'PUT', body: JSON.stringify(input) }),

  // ─── Valor de referência (tabela FIPE) ──────────────────────────────────────
  /** GET /v1/valor-referencia/candidatos → versões possíveis (valor_referencia:consultar). */
  buscarCandidatosValorReferencia: (termo: string, ano?: number, tipo?: string, zeroKm?: boolean) => {
    const q = new URLSearchParams({ termo })
    // Zero quilômetro e ano são excludentes no backend: veículo novo não tem
    // ano de modelo a filtrar, e mandar os dois é 400.
    if (zeroKm) q.set('zero_km', 'true')
    else if (ano) q.set('ano', String(ano))
    if (tipo) q.set('tipo', tipo)
    return apiRequest<{ candidatos: ValorReferenciaCandidato[]; modelos?: ValorReferenciaModelo[] }>(
      `/v1/valor-referencia/candidatos?${q}`,
    )
  },
  /** GET /v1/valor-referencia/anos → combinações ano+combustível de um código. */
  anosValorReferencia: (codigoFipe: string, tipo?: string) => {
    const q = new URLSearchParams({ codigo_fipe: codigoFipe })
    if (tipo) q.set('tipo', tipo)
    return apiRequest<{ anos: ValorReferenciaAno[] }>(`/v1/valor-referencia/anos?${q}`)
  },
  /**
   * GET /v1/valor-referencia → o valor, com procedência.
   *
   * `mesReferencia` é opcional: vazio consulta a tabela corrente (o caso da
   * cotação), preenchido reconsulta a tabela daquele mês — é assim que se
   * confere um valor já congelado contra a própria tabela que o produziu.
   * 402 = o mês existe mas está fora da janela do plano contratado.
   */
  valorReferencia: (codigoFipe: string, chaveAno: string, tipo?: string, mesReferencia?: string) => {
    const q = new URLSearchParams({ codigo_fipe: codigoFipe, chave_ano: chaveAno })
    if (tipo) q.set('tipo', tipo)
    if (mesReferencia) q.set('mes_referencia', mesReferencia)
    return apiRequest<ValorReferencia>(`/v1/valor-referencia?${q}`)
  },

  /** GET /v1/crm/fipe/marcas (crm:criar ou crm:editar); 422 tipo inválido, 503 catálogo indisponível. */
  listarMarcasFipeCrm: (tipo: TipoVeiculoCaptacao, busca?: string) => {
    const qs = new URLSearchParams({ tipo })
    if (busca) qs.set('busca', busca)
    return apiRequest<CatalogoCaptacaoResposta>(`/v1/crm/fipe/marcas?${qs.toString()}`)
  },
  /** GET /v1/crm/fipe/modelos: só os modelos que existem no ano (filtrado=false quando o ano não pôde filtrar). */
  listarModelosFipeCrm: (tipo: TipoVeiculoCaptacao, marca: string, ano: number, busca?: string) => {
    const qs = new URLSearchParams({ tipo, marca, ano: String(ano) })
    if (busca) qs.set('busca', busca)
    return apiRequest<CatalogoModelosCaptacaoResposta>(`/v1/crm/fipe/modelos?${qs.toString()}`)
  },
  /** GET /v1/crm/fipe/valor: valor exato da escolha completa (crm:criar ou crm:editar); 404 escolha inexistente, 503 provedor indisponível. */
  valorFipeCrm: (tipo: TipoVeiculoCaptacao, marca: string, modelo: string, chaveAno: string) => {
    const qs = new URLSearchParams({ tipo, marca, modelo, chave_ano: chaveAno })
    return apiRequest<ValorReferenciaCandidato>(`/v1/crm/fipe/valor?${qs.toString()}`)
  },
  /** GET /v1/crm/fipe/combustiveis; lista vazia = não perguntar, 404 = modelo inexistente neste ano. */
  listarCombustiveisFipeCrm: (tipo: TipoVeiculoCaptacao, marca: string, modelo: string, ano: number) => {
    const qs = new URLSearchParams({ tipo, marca, modelo, ano: String(ano) })
    return apiRequest<CatalogoCombustiveisCaptacaoResposta>(`/v1/crm/fipe/combustiveis?${qs.toString()}`)
  },

  // ─── Vistoria por bem do lead (mig 000092, Fase 2) ──────────────────────────
  /** GET /v1/crm/leads/{id}/bens/{bemId}/vistoria → 200 CrmLeadBemVistoria (crm:editar + escopo). 404 = ainda não habilitada. */
  crmVistoriaDoBem: (leadId: string, bemId: string) =>
    apiRequest<CrmLeadBemVistoria>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria`),
  /** POST /v1/crm/leads/{id}/bens/{bemId}/vistoria → 201 CrmLeadBemVistoria (crm:editar + escopo). 409 se já habilitada. */
  habilitarVistoriaBem: (leadId: string, bemId: string, eixos?: number) =>
    apiRequest<CrmLeadBemVistoria>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria`, {
      method: 'POST',
      ...(eixos !== undefined ? { body: JSON.stringify({ eixos }) } : {}),
    }),
  /** PATCH /v1/crm/leads/{id}/bens/{bemId}/vistoria → 200 CrmLeadBemVistoria (crm:gerenciar). Aprovar/reprovar com optimistic lock. */
  decidirVistoriaBem: (leadId: string, bemId: string, input: CrmDecisaoVistoriaInput) =>
    apiRequest<CrmLeadBemVistoria>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    }),

  /** POST .../vistoria/devolver → 200 CrmDevolucaoResultado (crm:gerenciar). Reprova fotos individuais e reabre o mesmo link do cliente. */
  devolverFotosVistoriaBem: (leadId: string, bemId: string, input: CrmDevolverFotosInput) =>
    apiRequest<CrmDevolucaoResultado>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/devolver`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  /** GET .../vistoria/analises → análises internas do bem (crm:gerenciar). */
  listarAnalisesVistoria: (leadId: string, bemId: string) =>
    apiRequest<{ analises: CrmAnaliseVistoria[] }>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/analises`).then((r) => r.analises),
  /** POST .../vistoria/analises → 201 (crm:gerenciar). Indício de fraude: avisa a gestão e bloqueia a aprovação. */
  abrirAnaliseVistoria: (leadId: string, bemId: string, input: { foto_id?: string; motivo: string; observacao?: string }) =>
    apiRequest<CrmAnaliseVistoria>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/analises`, { method: 'POST', body: JSON.stringify(input) }),
  /** POST .../vistoria/analises/{id}/concluir → 200 (crm:gerenciar + MFA). Outra pessoa que abriu; parecer obrigatório. */
  concluirAnaliseVistoria: (leadId: string, bemId: string, analiseId: string, input: { decisao: 'procedente' | 'improcedente'; parecer: string }) =>
    apiRequest<CrmAnaliseVistoria>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/analises/${analiseId}/concluir`, { method: 'POST', body: JSON.stringify(input) }),

  /** GET /v1/crm/vistoria/motivos-reprovacao → motivos ativos (crm:gerenciar); ?item=<codigo> filtra comuns + do item. */
  motivosReprovacaoVistoria: () =>
    apiRequest<{ itens: CrmMotivoReprovacao[] }>('/v1/crm/vistoria/motivos-reprovacao').then((r) => r.itens),

  // ─── Guia de fotos de vistoria — lado CONSULTOR (mig 000093, Fase 3) ───────
  /** POST .../vistoria/link → 201 CrmVistoriaLinkGerado (crm:gerenciar). Token só sai aqui. 409 (LINK_VISTORIA_JA_ATIVO) se já ativo. */
  gerarLinkVistoriaBem: (leadId: string, bemId: string) =>
    apiRequest<CrmVistoriaLinkGerado>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/link`, { method: 'POST' }),
  /**
   * POST .../vistoria/link/renovar → 201 CrmVistoriaLinkGerado (crm:gerenciar).
   * Expira o link ativo (se houver) e gera um novo — nunca dá 409, mesmo com
   * um link ainda ativo. Não "recupera" o link perdido (o token bruto nunca é
   * reexibido, ver CrmVistoriaLinkGerado); o antigo é revogado de verdade.
   */
  renovarLinkVistoriaBem: (leadId: string, bemId: string) =>
    apiRequest<CrmVistoriaLinkGerado>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/link/renovar`, { method: 'POST' }),
  /** GET .../vistoria/guia → CrmGuiaVistoria (crm:editar + escopo). Checklist + status por item. */
  crmGuiaVistoriaBem: (leadId: string, bemId: string) =>
    apiRequest<CrmGuiaVistoria>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/guia`),
  /** POST .../vistoria/fotos/{checklistItemId} → 201 CrmVistoriaFoto (crm:editar + escopo). Multipart. */
  // ─── Documentos pessoais do lead (#894) ──────────────────────────────────
  /** GET /v1/crm/leads/{id}/documentos → vigente de cada tipo (crm:ver). */
  documentosDoLead: (leadId: string) =>
    apiRequest<{ documentos: CrmLeadDocumento[] }>(`/v1/crm/leads/${leadId}/documentos`),
  /** GET /v1/crm/leads/{id}/pendencias-aceite → o que impede o aceite da proposta (crm:ver + escopo). */
  pendenciasAceiteDoLead: (leadId: string) =>
    apiRequest<{ pendencias: PendenciaAceiteLead[]; checklist?: ChecklistNegociacaoItem[] }>(
      `/v1/crm/leads/${leadId}/pendencias-aceite`,
    ),
  /** POST .../documentos → 201 (crm:editar). Substituir não sobrescreve: cria versão nova. */
  anexarDocumentoDoLead: (leadId: string, tipo: string, arquivo: File) => {
    const form = new FormData()
    form.append('tipo', tipo)
    form.append('arquivo', arquivo)
    return apiRequestUpload<CrmLeadDocumento>(`/v1/crm/leads/${leadId}/documentos`, form)
  },
  /**
   * GET .../documentos/{id}/arquivo → bytes (crm:ver_pii + MFA).
   *
   * Sempre por stream do servidor, nunca URL de bucket no browser: a
   * credencial de Storage não chega ao cliente, e cada download vira linha na
   * trilha de auditoria.
   */
  baixarDocumentoDoLead: (leadId: string, documentoId: string) =>
    apiRequestBlob(`/v1/crm/leads/${leadId}/documentos/${documentoId}/arquivo`),

  enviarFotoVistoriaBem: (leadId: string, bemId: string, checklistItemId: string, arquivo: File, geo: CrmGeoUpload) =>
    apiRequestUpload<CrmVistoriaFoto>(
      `/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/fotos/${checklistItemId}`,
      montarFormDataFotoVistoria(arquivo, geo),
    ),
  /** POST .../vistoria/presencial/fotos/{checklistItemId} → 201 CrmVistoriaFoto (crm:editar + escopo). Multipart; latitude/longitude obrigatórias (422 LOCALIZACAO_OBRIGATORIA). */
  enviarFotoVistoriaPresencial: (leadId: string, bemId: string, checklistItemId: string, arquivo: File, geo: CrmGeoUpload) =>
    apiRequestUpload<CrmVistoriaFoto>(
      `/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/presencial/fotos/${checklistItemId}`,
      montarFormDataFotoVistoria(arquivo, geo),
    ),
  /** POST .../vistoria/liberar → 201 (crm:editar + escopo). Habilita a vistoria e gera o link num pedido só; o token sai uma vez. 409 LINK_VISTORIA_JA_ATIVO se já há link ativo. */
  liberarVistoriaBem: (leadId: string, bemId: string, eixos?: number) =>
    apiRequest<CrmLiberarVistoriaResposta>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/liberar`, {
      method: 'POST',
      ...(eixos !== undefined ? { body: JSON.stringify({ eixos }) } : {}),
    }),
  /** POST .../vistoria/reabrir → 200 (crm:gerenciar + MFA). Uma única vez, antes da assinatura. 409 VISTORIA_JA_REABERTA | CONTRATO_ASSINADO. */
  reabrirVistoriaBem: (leadId: string, bemId: string, input: { motivo: string }) =>
    apiRequest<CrmLeadBemVistoria>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/reabrir`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** GET .../vistoria/fotos → { data: CrmVistoriaFoto[] } (crm:editar + escopo). Metadados, sem bytes. */
  listarFotosVistoriaBem: (leadId: string, bemId: string) =>
    apiRequest<{ data: CrmVistoriaFoto[] }>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/fotos`),
  /** GET .../vistoria/fotos/{fotoId} → Blob (crm:editar + escopo). Stream via BFF — nunca URL do storage. */
  baixarFotoVistoriaBem: (leadId: string, bemId: string, fotoId: string) =>
    apiRequestBlob(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/fotos/${fotoId}`),

  // ─── Laudo em PDF da decisão de vistoria (mig 000094, Fase 4) ─────────────
  /** GET .../vistoria/laudos → { data: CrmVistoriaLaudo[] } (crm:editar + escopo). Mais recente primeiro. */
  crmLaudosVistoriaBem: (leadId: string, bemId: string) =>
    apiRequest<{ data: CrmVistoriaLaudo[] }>(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/laudos`),
  /** GET .../vistoria/laudos/{laudoId} → Blob PDF (crm:editar + escopo). Stream via BFF — nunca URL do storage. */
  baixarLaudoVistoriaBem: (leadId: string, bemId: string, laudoId: string) =>
    apiRequestBlob(`/v1/crm/leads/${leadId}/bens/${bemId}/vistoria/laudos/${laudoId}`),

  // ─── Guia de fotos de vistoria — lado PÚBLICO (token na URL, sem sessão) ───
  // Sob /v1/vistoria-publica/ (não /vistoria/, que é a PÁGINA da SPA no
  // mesmo path — colidiriam no proxy do nginx da SPA, que só encaminha
  // /v1|/bff pro Go; hotfix pós-deploy do #522).
  /** GET /v1/vistoria-publica/{token} → CrmGuiaVistoria (unauth). 404 genérico se inválido; 410 se expirado. */
  crmGuiaVistoriaPublico: (token: string) =>
    apiRequest<CrmGuiaVistoria>(`/v1/vistoria-publica/${token}`, { skipAuth: true }),
  /** POST /v1/vistoria-publica/{token}/fotos/{checklistItemId} → 201 (unauth). Multipart, mesmas regras do lado consultor. */
  enviarFotoVistoriaPublico: (token: string, checklistItemId: string, arquivo: File, geo: CrmGeoUpload) =>
    apiRequestUpload<{ status: string; foto_id: string }>(
      `/v1/vistoria-publica/${token}/fotos/${checklistItemId}`,
      montarFormDataFotoVistoria(arquivo, geo),
      { skipAuth: true },
    ),
  /** GET /v1/vistoria-publica/{token}/fotos/{fotoId} → Blob (unauth). Achado "fotos invisíveis" — o associado reabre o link e revê o que já enviou. */
  baixarFotoVistoriaPublico: (token: string, fotoId: string) =>
    apiRequestBlob(`/v1/vistoria-publica/${token}/fotos/${fotoId}`, { skipAuth: true }),
  /** POST /v1/vistoria-publica/{token}/concluir → 200 (unauth). Reforma da vistoria, Parte B — o associado avisa que terminou; torna o link permanentemente inutilizável (reusa a expiração). 422 se ainda faltar foto de algum item. */
  concluirVistoriaPublico: (token: string) =>
    apiRequest<{ status: string }>(`/v1/vistoria-publica/${token}/concluir`, { method: 'POST', skipAuth: true }),

  // ─── Checklist de vistoria — admin (mig 000092, Fase 2) ────────────────────
  // RBAC crm:ver/crm:gerenciar (NÃO catalogo:ver/gerenciar — apesar da tela
  // viver em /crm/catalogo por conveniência, é um catálogo por-tenant do CRM,
  // não do catálogo comercial). Sem `version` no PATCH: o backend não
  // implementa optimistic lock pra este recurso (last-write-wins, confirmado
  // no repositório — diferente de Plano/Produto/Adicional).
  /** GET /v1/crm/vistoria-checklist?somente_ativos= → { data } (crm:ver). Default: só ativos. */
  listarChecklistVistoria: (somenteAtivos = true) =>
    apiRequest<{ data: ChecklistVistoriaItem[] }>(
      `/v1/crm/vistoria-checklist${paramsToQuery(somenteAtivos ? undefined : { somente_ativos: false })}`,
    ),
  /** POST /v1/crm/vistoria-checklist → 201 (crm:gerenciar). 409 (CHECKLIST_CODIGO_DUPLICADO) se código repetido no tenant. */
  criarChecklistVistoriaItem: (input: ChecklistVistoriaItemInput) =>
    apiRequest<ChecklistVistoriaItem>('/v1/crm/vistoria-checklist', { method: 'POST', body: JSON.stringify(input) }),
  /** PATCH /v1/crm/vistoria-checklist/{id} → 200 (crm:gerenciar). Parcial — rotulo/ordem/ativo. */
  atualizarChecklistVistoriaItem: (id: string, input: ChecklistVistoriaItemPatch) =>
    apiRequest<ChecklistVistoriaItem>(`/v1/crm/vistoria-checklist/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),

  // ─── Limites de desconto e acréscimo (#889) ────────────────────────────────
  // Regra versionada: alterar não sobrescreve, supersede — proposta fechada
  // ontem continua explicada pela regra de ontem. Por isso não há PUT: só
  // criação, aprovação e encerramento.
  /** GET /v1/regras-desconto-acrescimo → { data } (desconto_acrescimo:ver). */
  listarRegrasDescontoAcrescimo: (filtro?: RegraDescontoAcrescimoFiltro) =>
    apiRequest<{ data: RegraDescontoAcrescimo[] }>(
      `/v1/regras-desconto-acrescimo${paramsToQuery(filtro)}`,
    ),
  /** POST /v1/regras-desconto-acrescimo → 201 (desconto_acrescimo:configurar, crítica/MFA). 422 se o limite vier em percentual E em centavos. */
  criarRegraDescontoAcrescimo: (input: RegraDescontoAcrescimoInput) =>
    apiRequest<RegraDescontoAcrescimo>('/v1/regras-desconto-acrescimo', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** POST /v1/regras-desconto-acrescimo/{id}/aprovar → 204 (desconto_acrescimo:aprovar, crítica/MFA). 409 AUTO_APROVACAO se for quem propôs. */
  aprovarRegraDescontoAcrescimo: (id: string, version: number) =>
    apiRequest<void>(`/v1/regras-desconto-acrescimo/${id}/aprovar`, {
      method: 'POST',
      body: JSON.stringify({ version }),
    }),
  /** DELETE /v1/regras-desconto-acrescimo/{id} → 204 (desconto_acrescimo:configurar). Supersede: encerra a vigência, não apaga o passado. */
  encerrarRegraDescontoAcrescimo: (id: string, version: number) =>
    apiRequest<void>(`/v1/regras-desconto-acrescimo/${id}`, {
      method: 'DELETE',
      body: JSON.stringify({ version }),
    }),

  // ─── Faixas de acréscimo por critério objetivo (#891) ───────────────────────
  // Mesmo recurso de RBAC do #889 (desconto_acrescimo): faixa e teto são a
  // mesma conversa sobre o preço da venda, e quem configura um configura o
  // outro.
  /** GET /v1/faixas-acrescimo → { data } (desconto_acrescimo:ver). */
  listarFaixasAcrescimo: (filtro?: FaixaAcrescimoFiltro) =>
    apiRequest<{ data: FaixaAcrescimo[] }>(`/v1/faixas-acrescimo${paramsToQuery(filtro)}`),
  /** POST /v1/faixas-acrescimo → 201 (desconto_acrescimo:configurar, crítica/MFA). 409 FAIXA_SOBREPOSTA se invadir faixa vigente. */
  criarFaixaAcrescimo: (input: FaixaAcrescimoInput) =>
    apiRequest<FaixaAcrescimo>('/v1/faixas-acrescimo', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** POST /v1/faixas-acrescimo/{id}/aprovar → faixa (desconto_acrescimo:aprovar, crítica/MFA). 409 AUTO_APROVACAO se for quem propôs. */
  aprovarFaixaAcrescimo: (id: string, version: number) =>
    apiRequest<FaixaAcrescimo>(`/v1/faixas-acrescimo/${id}/aprovar`, {
      method: 'POST',
      body: JSON.stringify({ version }),
    }),
  /** DELETE /v1/faixas-acrescimo/{id} → 204 (desconto_acrescimo:configurar). Supersede: a proposta fechada sob ela continua explicada. */
  encerrarFaixaAcrescimo: (id: string, version: number) =>
    apiRequest<void>(`/v1/faixas-acrescimo/${id}`, {
      method: 'DELETE',
      body: JSON.stringify({ version }),
    }),
  /** POST /v1/faixas-acrescimo/simular → régua vigente × com propostas para um bem hipotético; sem escrita (desconto_acrescimo:ver, #891). */
  simularFaixaAcrescimo: (input: SimulacaoFaixaInput) =>
    apiRequest<SimulacaoFaixa>('/v1/faixas-acrescimo/simular', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** GET /v1/faixas-acrescimo/{id}/impacto → quantos bens a faixa alcança hoje (desconto_acrescimo:ver, #891). */
  impactoFaixaAcrescimo: (id: string) => apiRequest<ImpactoFaixa>(`/v1/faixas-acrescimo/${id}/impacto`),
  /** GET /v1/faixas-acrescimo/historico → linha do tempo, supersedidas inclusive, com quem propôs e aprovou (desconto_acrescimo:ver, #891). */
  historicoFaixasAcrescimo: (filtro?: Omit<FaixaAcrescimoFiltro, 'status'>) =>
    apiRequest<{ data: MarcoFaixaAcrescimo[] }>(`/v1/faixas-acrescimo/historico${paramsToQuery(filtro)}`),

  // ─── Catálogo de Planos de Proteção (CRM Fase 2, PR1 backend) ───────────────
  /** GET /v1/catalogo/planos → { planos } (catalogo:ver). ?ativos=true filtra inativos. */
  listarPlanosProtecao: (apenasAtivos?: boolean) =>
    apiRequest<{ planos: PlanoProtecao[] }>(
      `/v1/catalogo/planos${paramsToQuery(apenasAtivos ? { ativos: true } : undefined)}`,
    ),
  /** GET /v1/catalogo/planos/{id} → plano + itens (catalogo:ver). */
  obterPlanoProtecao: (id: string) => apiRequest<PlanoProtecao>(`/v1/catalogo/planos/${id}`),
  /** GET /v1/catalogo/planos/{id}/impacto-desativacao → o que a desativação alcança (catalogo:gerenciar). */
  impactoDesativacaoPlano: (id: string) =>
    apiRequest<ImpactoDesativacaoPlano>(`/v1/catalogo/planos/${id}/impacto-desativacao`),
  /** POST /v1/catalogo/planos → 201 (catalogo:gerenciar). */
  criarPlanoProtecao: (input: PlanoProtecaoInput) =>
    apiRequest<PlanoProtecao>('/v1/catalogo/planos', { method: 'POST', body: JSON.stringify(input) }),
  /** PUT /v1/catalogo/planos/{id} → 200 (catalogo:gerenciar). Envia version (optimistic lock; 409). */
  atualizarPlanoProtecao: (id: string, input: PlanoProtecaoInput) =>
    apiRequest<PlanoProtecao>(`/v1/catalogo/planos/${id}`, { method: 'PUT', body: JSON.stringify(input) }),
  /** PUT multipart /v1/catalogo/planos/{id}/imagem (catalogo:gerenciar). JPG ou PNG até 500 KB e 2000 px; o servidor confere pelo conteúdo. */
  enviarImagemPlano: (id: string, arquivo: File) => {
    const form = new FormData()
    form.append('imagem', arquivo)
    return apiRequestUpload<PlanoProtecao>(`/v1/catalogo/planos/${id}/imagem`, form, { method: 'PUT' })
  },
  removerImagemPlano: (id: string) =>
    apiRequest<PlanoProtecao>(`/v1/catalogo/planos/${id}/imagem`, { method: 'DELETE' }),
  baixarImagemPlano: (id: string) => apiRequestBlob(`/v1/catalogo/planos/${id}/imagem`),
  /** GET /v1/catalogo/adicionais → { adicionais } (catalogo:ver). ?ativos=true filtra inativos. */
  /** GET /v1/catalogo/produtos → { produtos } (catalogo:ver). */
  listarProdutosCatalogo: (apenasAtivos?: boolean) =>
    apiRequest<{ produtos: ProdutoCatalogo[] }>(
      `/v1/catalogo/produtos${paramsToQuery(apenasAtivos ? { ativos: true } : undefined)}`,
    ),
  /** POST /v1/catalogo/produtos → 201 (catalogo:gerenciar). */
  criarProdutoCatalogo: (input: ProdutoCatalogoInput) =>
    apiRequest<ProdutoCatalogo>('/v1/catalogo/produtos', { method: 'POST', body: JSON.stringify(input) }),
  /** PUT /v1/catalogo/produtos/{id} → 200 (catalogo:gerenciar). Envia version (409 = conflito). */
  atualizarProdutoCatalogo: (id: string, input: ProdutoCatalogoInput) =>
    apiRequest<ProdutoCatalogo>(`/v1/catalogo/produtos/${id}`, { method: 'PUT', body: JSON.stringify(input) }),

  listarAdicionaisCatalogo: (apenasAtivos?: boolean) =>
    apiRequest<{ adicionais: AdicionalCatalogo[] }>(
      `/v1/catalogo/adicionais${paramsToQuery(apenasAtivos ? { ativos: true } : undefined)}`,
    ),
  /** POST /v1/catalogo/adicionais → 201 (catalogo:gerenciar). */
  criarAdicionalCatalogo: (input: AdicionalCatalogoInput) =>
    apiRequest<AdicionalCatalogo>('/v1/catalogo/adicionais', { method: 'POST', body: JSON.stringify(input) }),
  /** PUT /v1/catalogo/adicionais/{id} → 200 (catalogo:gerenciar). Envia version (optimistic lock; 409). */
  atualizarAdicionalCatalogo: (id: string, input: AdicionalCatalogoInput) =>
    apiRequest<AdicionalCatalogo>(`/v1/catalogo/adicionais/${id}`, { method: 'PUT', body: JSON.stringify(input) }),
  /** GET /v1/catalogo/conflitos → { conflitos } (catalogo:ver). Cada par uma vez. */
  listarConflitosCatalogo: () => apiRequest<{ conflitos: ConflitoCatalogo[] }>('/v1/catalogo/conflitos'),
  /** PUT /v1/catalogo/{produtos|adicionais}/{id}/conflitos → { version } (catalogo:gerenciar). Troca a lista inteira; 409 = versão velha. */
  definirConflitosCatalogo: (
    lado: LadoConflitoCatalogo,
    id: string,
    version: number,
    conflitos: Array<{ tipo: LadoConflitoCatalogo; id: string }>,
  ) =>
    apiRequest<{ version: number }>(`/v1/catalogo/${lado === 'produto' ? 'produtos' : 'adicionais'}/${id}/conflitos`, {
      method: 'PUT',
      body: JSON.stringify({ version, conflitos }),
    }),

  // ─── Proposta de adesão na ficha do lead (CRM Fase 2, PR3) ──────────────────
  /** GET /v1/crm/leads/{id}/propostas → { propostas } (crm:ver). Valores do snapshot. */
  listarPropostasLead: (leadId: string) =>
    apiRequest<{ propostas: PropostaAdesao[] }>(`/v1/crm/leads/${leadId}/propostas`),
  /** POST /v1/crm/leads/{id}/propostas → 201 (crm:editar). O servidor congela o snapshot. */
  criarPropostaLead: (leadId: string, input: PropostaAdesaoInput) =>
    apiRequest<PropostaAdesao>(`/v1/crm/leads/${leadId}/propostas`, { method: 'POST', body: JSON.stringify(input) }),
  /** GET /v1/crm/negociacao/meus-limites (crm:editar). */
  meusLimitesNegociacao: (aplicacao: AplicacaoNegociacao) =>
    apiRequest<{ limites: LimiteNegociacao[] }>(`/v1/crm/negociacao/meus-limites?aplicacao=${aplicacao}`),
  /** POST /v1/crm/recomendacao (crm:editar). Planos, participação e limites para o bem; não grava. */
  recomendarPlano: (aplicacao: AplicacaoNegociacao, input: RecomendacaoPlanoInput) =>
    apiRequest<RecomendacaoPlano>(`/v1/crm/recomendacao?aplicacao=${aplicacao}`, { method: 'POST', body: JSON.stringify(input) }),
  /** POST /v1/crm/leads/{id}/propostas/previa (crm:editar). Mesmo corpo da geração; não grava. */
  previaPropostaLead: (leadId: string, aplicacao: AplicacaoNegociacao, input: PropostaAdesaoInput) =>
    apiRequest<PreviaProposta>(`/v1/crm/leads/${leadId}/propostas/previa?aplicacao=${aplicacao}`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /**
   * POST /v1/associados/{id}/propostas → 201 (crm:editar) — PR B, associado
   * já ativo escolhendo plano pra um bem que já é bem_protegido. Resolve o
   * lead de origem server-side; reusa 100% da validação/snapshot/auditoria
   * de criarPropostaLead. A proposta criada aparece normalmente na ficha do
   * lead (mesmo lead_id) — o aceite é feito lá, sem fluxo novo aqui.
   */
  criarPropostaParaAssociado: (associadoId: string, input: PropostaAdesaoAssociadoInput) =>
    apiRequest<PropostaAdesao>(`/v1/associados/${associadoId}/propostas`, { method: 'POST', body: JSON.stringify(input) }),
  /**
   * POST /v1/catalogo/propostas/{id}/aceitar → aceita a proposta (crm:editar,
   * dono do lead ou gestão do CRM, sob MFA). Não converte o lead nem emite
   * boleto; 422 "complete os dados" se faltar documento do veículo ou dado do
   * lead. Idempotente (já aceita devolve o estado). O boleto de adesão sai
   * depois, por ação própria: services/adesao-api.ts.
   */
  aceitarProposta: (propostaId: string) =>
    apiRequest<AceitarPropostaResultado>(`/v1/catalogo/propostas/${propostaId}/aceitar`, { method: 'POST' }),
  /**
   * POST /v1/catalogo/propostas/{id}/recusar → recusa a proposta (crm:editar,
   * sem MFA — decisão comercial, nenhum dinheiro movimentado). Só aceita a
   * transição rascunho → recusada; proposta já aceita devolve 422.
   */
  recusarProposta: (propostaId: string) =>
    apiRequest<PropostaAdesao>(`/v1/catalogo/propostas/${propostaId}/recusar`, { method: 'POST' }),
  /**
   * GET /v1/catalogo/propostas/{id}/contrato → Blob PDF do Contrato de Adesão
   * (crm:ver + escopo). Só existe para proposta ACEITA (`situacao === 'aceita'`);
   * pedir antes disso deve dar erro do backend, não crash — o client trata via
   * ApiError (mapCrmError). Stream via BFF — nunca URL do storage. Mesmo padrão
   * de `baixarLaudoVistoriaBem` (PR "laudo em PDF da vistoria").
   */
  baixarContratoProposta: (propostaId: string) =>
    apiRequestBlob(`/v1/catalogo/propostas/${propostaId}/contrato`),

  // ─── Compartilhamento de proposta (paridade PowerCRM, 02/09/2026) ─────────
  /**
   * POST /v1/crm/leads/{id}/compartilhamentos → 201 (crm:editar). Gera o link
   * público de 1+ propostas — "proposta pronta" (1) e "comparação de planos"
   * (2+) são a MESMA rota. O token só existe nesta resposta.
   */
  criarCompartilhamentoLead: (leadId: string, input: CompartilhamentoInput) =>
    apiRequest<CompartilhamentoGerado>(`/v1/crm/leads/${leadId}/compartilhamentos`, { method: 'POST', body: JSON.stringify(input) }),
  /**
   * GET /v1/catalogo/propostas/{id}/proposta-pdf → Blob PDF da Proposta de
   * Adesão PRÉ-ACEITE (crm:editar). Ao contrário de baixarContratoProposta,
   * funciona com a proposta em 'rascunho' — é o ponto desta rota.
   */
  baixarPropostaPdf: (propostaId: string) =>
    apiRequestBlob(`/v1/catalogo/propostas/${propostaId}/proposta-pdf`),
  /**
   * GET /v1/proposta-publica/{token} → resumo mascarado, SEM sessão (unauth).
   * Mesmo padrão skipAuth de vistoria-publica/assinatura-publica. 404
   * genérico se o token não existe; 410 se expirado.
   */
  buscarPropostaPublica: (token: string) =>
    apiRequest<CompartilhamentoPublicoResumo>(`/v1/proposta-publica/${token}`, { skipAuth: true }),
  /**
   * POST /v1/proposta-publica/{token}/escolher → 200 (unauth). Registra só a
   * ESCOLHA do lead — não aceita a proposta (o aceite do cliente é
   * services/adesao-api.ts) nem emite boleto. Idempotente: reescolher
   * sobrescreve.
   */
  escolherPropostaPublica: (token: string, input: EscolherPropostaPublicaInput) =>
    apiRequest<CompartilhamentoPublicoResumo>(`/v1/proposta-publica/${token}/escolher`, {
      method: 'POST',
      body: JSON.stringify(input),
      skipAuth: true,
    }),

  // ─── Comparação de PLANOS do catálogo (refinamento 02/09/2026) ────────────
  /**
   * POST /v1/crm/leads/{id}/comparacoes → 201 (crm:editar). Gera o link
   * público de comparação de PLANOS (>= 2). NÃO cria proposta — só o link.
   */
  criarComparacaoLead: (leadId: string, input: ComparacaoInput) =>
    apiRequest<CompartilhamentoGerado>(`/v1/crm/leads/${leadId}/comparacoes`, { method: 'POST', body: JSON.stringify(input) }),
  /**
   * GET /v1/comparacao-publica/{token} → resumo mascarado, SEM sessão. Mesmo
   * shape do resumo público — cada "proposta" do resumo é na verdade um PLANO.
   */
  buscarComparacaoPublica: (token: string) =>
    apiRequest<CompartilhamentoPublicoResumo>(`/v1/comparacao-publica/${token}`, { skipAuth: true }),
  /**
   * POST /v1/comparacao-publica/{token}/escolher → 200 (unauth). Registra a
   * escolha do plano e GERA 1 proposta rascunho do plano escolhido — NUNCA
   * aceita nem emite boleto (isso segue do lado do consultor, com MFA).
   */
  escolherPlanoPublico: (token: string, input: EscolherPlanoPublicoInput) =>
    apiRequest<CompartilhamentoPublicoResumo>(`/v1/comparacao-publica/${token}/escolher`, {
      method: 'POST',
      body: JSON.stringify(input),
      skipAuth: true,
    }),
  /**
   * POST /v1/catalogo/propostas/{id}/signing-sessions → 201 (assinatura:criar).
   * Ponte PR3 (`internal/catalogo/assinatura_handler.go`): congela a
   * contract_version da proposta ACEITA + cria a sessão de assinatura, num só
   * passo — o consultor só conhece a proposta, nunca
   * contract_version_id/customer_id (vocabulário interno de
   * internal/assinatura). 409 se a proposta ainda não foi aceita.
   */
  criarSessaoAssinatura: (propostaId: string, mode: AssinaturaModo) =>
    apiRequest<AssinaturaSessao>(`/v1/catalogo/propostas/${propostaId}/signing-sessions`, {
      method: 'POST',
      body: JSON.stringify({ mode }),
    }),
  /**
   * GET /v1/catalogo/propostas/{id}/signing-sessions → histórico de sessões
   * de assinatura da proposta (assinatura:ver), mais recente primeiro
   * (`sessoes[0]` = card "atual"). Proposta sem nenhuma sessão ainda →
   * `{ sessoes: [] }` (200 — estado válido do funil, não erro). Alimenta o
   * card de status completo do CRM (PR5) — NUNCA traz o token cru.
   */
  listarSessoesAssinatura: (propostaId: string) =>
    apiRequest<{ sessoes: AssinaturaSessaoHistoricoItem[] }>(`/v1/catalogo/propostas/${propostaId}/signing-sessions`),
  /**
   * GET /v1/signing-sessions/{id}/audit-events → linha do tempo de
   * evidências da sessão, já traduzida (assinatura:ver), ordem cronológica
   * ASC. 404 se a sessão não existe. Buscado SOB DEMANDA (só quando o
   * "Ver histórico" do card abre) — nunca pré-carregado.
   */
  auditEventsSessao: (sessionId: string) =>
    apiRequest<{ eventos: AssinaturaAuditEvento[] }>(`/v1/signing-sessions/${sessionId}/audit-events`),
  /**
   * POST /v1/catalogo/propostas/{id}/signing-sessions/reenviar → 201
   * (assinatura:criar). NÃO reenvia o link antigo — impossível por design
   * (o token cru só existe 1x, na resposta HTTP da criação; nunca fica
   * persistido em claro). Revoga a sessão ativa atual (se existir) e cria
   * uma sessão NOVA do zero, com token NOVO — mesmo shape de
   * `criarSessaoAssinatura`. `mode` omitido herda o modo da sessão mais
   * recente (decisão do backend). 409 PROPOSTA_NAO_ACEITA se a proposta não
   * estiver aceita.
   */
  reenviarSessaoAssinatura: (propostaId: string, mode?: AssinaturaModo) =>
    apiRequest<AssinaturaSessao>(`/v1/catalogo/propostas/${propostaId}/signing-sessions/reenviar`, {
      method: 'POST',
      body: JSON.stringify(mode ? { mode } : {}),
    }),
  /**
   * GET /v1/signing-sessions/{id}/documento → Blob PDF do documento assinado
   * (assinatura:ver), AUTENTICADO como staff — diferente do download
   * público de `baixarDocumentoAssinadoPublico` (token na URL, sem
   * sessão). Existe porque o staff nunca tem o token cru do cliente (só
   * existiu 1x, na resposta de criação). Só funciona com a sessão SIGNED
   * (409 DOCUMENTO_INDISPONIVEL antes disso) — o botão "Ver contrato" do
   * card só aparece quando `status === 'SIGNED'`.
   */
  baixarDocumentoAssinaturaStaff: (sessionId: string) =>
    apiRequestBlob(`/v1/signing-sessions/${sessionId}/documento`),
  /**
   * POST /v1/signing-sessions/{id}/revoke → cancela a sessão de assinatura
   * (assinatura:cancelar + MFA/aal2 — rota já existente desde o PR1). SEM
   * corpo/motivo (diferente de `cancelarBoleto`, que exige motivo). 409
   * TRANSICAO_INVALIDA se a sessão já está num estado terminal (revogar 2x
   * não é idempotente).
   */
  revogarSessaoAssinatura: (sessionId: string) =>
    apiRequest<{ id: string; status: AssinaturaStatus; version: number }>(`/v1/signing-sessions/${sessionId}/revoke`, {
      method: 'POST',
    }),
  // ─── Captação de leads (CRM Fase 3, PR1 backend) — admin ────────────────────
  /** GET /v1/captacao/formularios → { formularios } com contagem de leads (captacao:ver). */
  listarFormulariosCaptacao: (apenasAtivos?: boolean) =>
    apiRequest<{ formularios: FormularioCaptacaoComContagem[] }>(
      `/v1/captacao/formularios${paramsToQuery(apenasAtivos ? { ativos: true } : undefined)}`,
    ),
  /** POST /v1/captacao/formularios → 201 (captacao:gerenciar). O slug é gerado pelo backend. */
  criarFormularioCaptacao: (input: FormularioCaptacaoInput) =>
    apiRequest<FormularioCaptacao>('/v1/captacao/formularios', { method: 'POST', body: JSON.stringify(input) }),
  /** PATCH /v1/captacao/formularios/{id} → 200 (captacao:gerenciar). Envia version (optimistic lock; 409). */
  atualizarFormularioCaptacao: (id: string, input: FormularioCaptacaoInput) =>
    apiRequest<FormularioCaptacao>(`/v1/captacao/formularios/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  /**
   * GET /v1/voluntarios?busca= → seletor administrativo (id+nome) pro
   * roteamento de comissão do Powerlink (captacao:gerenciar). Endpoint
   * propositalmente estreito — nenhum dado sensível de voluntário.
   */
  voluntarios: (busca?: string) =>
    apiRequest<{ data: VoluntarioResumo[] }>(`/v1/voluntarios${paramsToQuery(busca ? { busca } : undefined)}`),
  // ─── Captação PÚBLICA (unauth — página /captacao/:slug) ─────────────────────
  /** GET /v1/captacao/{slug} → config de render (público, skipAuth). 404 genérico. */
  renderFormularioCaptacaoPublico: (slug: string) =>
    apiRequest<RenderFormularioCaptacao>(`/v1/captacao/${encodeURIComponent(slug)}`, { skipAuth: true }),
  /** POST /v1/captacao/{slug} → { status, mensagem } (público, skipAuth). Resposta genérica. */
  submeterCaptacaoPublico: (slug: string, input: SubmissaoCaptacaoInput) =>
    apiRequest<RespostaSubmissaoCaptacao>(`/v1/captacao/${encodeURIComponent(slug)}`, {
      method: 'POST',
      skipAuth: true,
      body: JSON.stringify(input),
    }),

  /** POST /v1/captacao/{slug}/simular → estimativa por plano (público, skipAuth, canal simulador). */
  simularCaptacaoPublico: (slug: string, input: SimulacaoInput) =>
    apiRequest<SimulacaoResultado>(`/v1/captacao/${encodeURIComponent(slug)}/simular`, {
      method: 'POST',
      skipAuth: true,
      body: JSON.stringify(input),
    }),
  /** POST /v1/crm/simulacao → mesma estimativa para o consultor (crm:criar ou catalogo:ver). */
  simularContribuicaoCrm: (input: SimulacaoInput) =>
    apiRequest<SimulacaoResultado>('/v1/crm/simulacao', { method: 'POST', body: JSON.stringify(input) }),

  // ─── Assinatura eletrônica PÚBLICA (unauth — página /assinar/:token, PR3) ──
  // Rotas + DTOs conferidos contra o código real do backend (PR3, mesma
  // frente, mergeado no worktree em paralelo — internal/assinatura/
  // handler_publico.go). Mesmo padrão skipAuth de vistoria-publica/captacao:
  // token na própria URL é a autenticação.
  /** GET /v1/assinatura-publica/{token} → resumo seguro da sessão (unauth). 404 genérico; 410 se expirada. */
  assinaturaPublica: (token: string) =>
    apiRequest<AssinaturaPublicaSessao>(`/v1/assinatura-publica/${token}`, { skipAuth: true }),
  /** POST /v1/assinatura-publica/{token}/abrir → SENT→OPENED→OTP_PENDING (unauth). Chamado 1x ao montar; idempotente. */
  abrirAssinaturaPublica: (token: string) =>
    apiRequest<AssinaturaAcaoPublicaResp>(`/v1/assinatura-publica/${token}/abrir`, { method: 'POST', skipAuth: true }),
  /**
   * POST /v1/assinatura-publica/{token}/otp/confirmar-debug → OTP_PENDING→
   * IDENTITY_VERIFIED, substitui a validação OTP real (PR2 bloqueado por
   * procurement). SÓ existe fora de prod (RegisterPublicDebugRoutes, gated
   * por cfg.Env != "prod" no router.go) — 404 em produção é esperado,
   * tratado como mensagem honesta na Tela 2 (ver erro-publico.ts), não um crash.
   */
  confirmarOtpDebugAssinaturaPublica: (token: string) =>
    apiRequest<AssinaturaAcaoPublicaResp>(`/v1/assinatura-publica/${token}/otp/confirmar-debug`, {
      method: 'POST',
      skipAuth: true,
    }),
  /** POST /v1/assinatura-publica/{token}/view → IDENTITY_VERIFIED→DOCUMENT_VIEWED (unauth). Idempotente. */
  registrarViewAssinaturaPublica: (token: string) =>
    apiRequest<AssinaturaAcaoPublicaResp>(`/v1/assinatura-publica/${token}/view`, { method: 'POST', skipAuth: true }),
  /** POST /v1/assinatura-publica/{token}/consent → { accepted: true } (unauth). DOCUMENT_VIEWED→CONSENTED se aceito. */
  registrarConsentAssinaturaPublica: (token: string) =>
    apiRequest<AssinaturaAcaoPublicaResp>(`/v1/assinatura-publica/${token}/consent`, {
      method: 'POST',
      skipAuth: true,
      body: JSON.stringify({ accepted: true }),
    }),
  /**
   * POST /v1/assinatura-publica/{token}/signature → CONSENTED→SIGNED (unauth).
   * `imagem_png_base64` aceita data URL completa (o que `SignaturePad.toDataURL()`
   * já devolve) ou base64 puro. Idempotente por sessão do lado do backend — em
   * erro 500 é seguro o cliente reenviar o MESMO gesto (não duplica).
   */
  enviarAssinaturaPublica: (
    token: string,
    body: { imagem_png_base64: string; largura_px: number; altura_px: number },
  ) =>
    apiRequest<AssinaturaAcaoPublicaResp>(`/v1/assinatura-publica/${token}/signature`, {
      method: 'POST',
      skipAuth: true,
      body: JSON.stringify(body),
    }),
  /**
   * GET /v1/assinatura-publica/{token}/documento → Blob PDF do contrato
   * assinado (unauth). Só funciona com a sessão em SIGNED — 409
   * `DOCUMENTO_INDISPONIVEL` antes disso (defesa em profundidade; o client só
   * chama isto quando `status === 'SIGNED'`). Mesmo padrão skipAuth de
   * `/v1/vistoria-publica/{token}/fotos/{fotoId}`.
   */
  baixarDocumentoAssinadoPublico: (token: string) =>
    apiRequestBlob(`/v1/assinatura-publica/${token}/documento`, { skipAuth: true }),
  /**
   * GET /v1/cooperativas → catálogo de cooperativas ativas (W1-104). Só
   * autenticação — dado de referência sem PII, compartilhado com Associados.
   * `sugerida_id`: cooperativa do membro da Rede Comercial do usuário logado
   * (null sem vínculo), independente das flags rede.*.
   */
  cooperativas: () => apiRequest<{ data: CooperativaResumo[]; sugerida_id?: string | null }>('/v1/cooperativas'),
  /** GET /v1/voluntario/carteira?modo=ativos|historico — carteira do voluntário logado (#230). */
  voluntarioCarteira: (modo: ModoCarteira = 'ativos', cursor?: string) =>
    apiRequest<CarteiraVoluntario>(`/v1/voluntario/carteira${paramsToQuery({ modo, cursor })}`),
  /** GET /v1/voluntario/minha-meta → meta ativa do voluntário logado + progresso (#233). */
  minhaMeta: () => apiRequest<MinhaMeta>('/v1/voluntario/minha-meta'),
  /** GET /v1/voluntario/metas → { data } (crm:gerenciar/voluntario:gerenciar) —
   * visão de gestor de todas as metas dos parceiros (#233, PR1). */
  metasGestor: () => apiRequest<{ data: MetaGestor[] }>('/v1/voluntario/metas'),
  /** POST /v1/voluntario/metas → 201 (voluntario:gerenciar). A resposta é a
   * meta criada SEM `voluntario_nome`/`valor_atual` (campos exclusivos da
   * visão de lista de gestor) — por isso o tipo de retorno omite os dois;
   * quem precisar do nome já sabe o parceiro que selecionou. */
  criarMeta: (input: CriarMetaInput) =>
    apiRequest<Omit<MetaGestor, 'voluntario_nome' | 'indicacoes_atual' | 'valor_atual' | 'fora_da_rede' | 'fonte_rede'>>('/v1/voluntario/metas', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** PATCH /v1/voluntario/metas/{id}/status → 200 (voluntario:gerenciar,
   * mesma omissão de `voluntario_nome`/`valor_atual` do POST). Optimistic
   * lock via `version`; 409 VERSAO_DIVERGENTE se outra edição concorrente
   * já mudou a meta. Se a meta tinha recompensa financeira e bateu, dispara
   * comissão por trás. */
  atualizarStatusMeta: (id: string, statusRecompensa: MetaGestor['status_recompensa'], version: number) =>
    apiRequest<Omit<MetaGestor, 'voluntario_nome' | 'indicacoes_atual' | 'valor_atual' | 'fora_da_rede' | 'fonte_rede'>>(`/v1/voluntario/metas/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status_recompensa: statusRecompensa, version }),
    }),
  /** GET /v1/crm/ranking-parceiros?mes=YYYY-MM (voluntario:gerenciar). */
  rankingParceirosGestor: (mes: string) =>
    apiRequest<RankingParceirosGestor>(`/v1/crm/ranking-parceiros${paramsToQuery({ mes })}`),
  /** GET /v1/voluntario/minhas-comissoes → extrato real do parceiro logado (issue #232, PR1). */
  minhasComissoes: () => apiRequest<ExtratoComissoes>('/v1/voluntario/minhas-comissoes'),
  /** PATCH /v1/voluntario/{id}/percentual-comissao → gestor define a comissão do
   * parceiro (crm:gerenciar). `percentualComissao=null` limpa/desativa. 422 VALIDATION_ERROR. */
  atualizarPercentualComissao: (voluntarioId: string, percentualComissao: string | null) =>
    apiRequest<{ percentual_comissao: string | null }>(`/v1/voluntario/${voluntarioId}/percentual-comissao`, {
      method: 'PATCH',
      body: JSON.stringify({ percentual_comissao: percentualComissao }),
    }),
  /** POST /v1/voluntario/{id}/dados-pagamento → 201 (crm:gerenciar). Cadastro
   * único do fornecedor do parceiro (write-only). 422 se já cadastrado. */
  cadastrarDadosPagamentoParceiro: (voluntarioId: string, input: DadosPagamentoInput) =>
    apiRequest<void>(`/v1/voluntario/${voluntarioId}/dados-pagamento`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** POST /v1/comissoes/{id}/gerar-titulo → 200 (crm:gerenciar). Sem corpo.
   * 422 sem dados de pagamento; 409 comissão não está mais pendente. */
  gerarTituloComissao: (comissaoId: string) =>
    apiRequest<TituloGeradoResumo>(`/v1/comissoes/${comissaoId}/gerar-titulo`, { method: 'POST' }),
  /** POST /v1/comissoes/gerar-titulo-lote → 200 { data } (crm:gerenciar).
   * "Gerar todos" (PR3b, #232/#491) — sem corpo, sem seleção manual: o
   * servidor decide sozinho quem é elegível (mesmo critério do botão
   * individual). Sempre 200 mesmo com itens falhos — cada item do array
   * carrega sucesso/erro (ver ResultadoLoteItem). */
  gerarTituloComissaoLote: () =>
    apiRequest<{ data: ResultadoLoteItem[] }>('/v1/comissoes/gerar-titulo-lote', { method: 'POST' }),
  /** GET /v1/comissoes → { data } (crm:gerenciar) — visão de gestor de todas
   * as comissões. ?status=pendente|processando filtra; sem query = todas. */
  comissoesGestor: (status?: ComissaoStatus) =>
    apiRequest<{ data: ComissaoGestor[] }>(`/v1/comissoes${paramsToQuery(status ? { status } : undefined)}`),

  // ─── Financeiro Corporativo (WFC-1) — razão operacional ───────────────────
  // Leitura: financeiro:ver. Configuração de plano de contas/centro de custo:
  // financeiro:configurar. Lançamento manual: financeiro:lancar.

  /** GET /v1/financeiro/plano-contas → sem paginação (envelope { data }). */
  planoContas: (params?: PlanoContaListParams) =>
    apiRequest<{ data: PlanoConta[] }>(`/v1/financeiro/plano-contas${paramsToQuery(params)}`),
  /** POST /v1/financeiro/plano-contas → 201 PlanoConta. 422 VALIDATION_ERROR. */
  planoContaCriar: (input: PlanoContaInput) =>
    apiRequest<PlanoConta>('/v1/financeiro/plano-contas', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** PATCH /v1/financeiro/plano-contas/{id} → 200 PlanoConta. 409 CONFLITO_VERSAO. */
  planoContaEditar: (id: string, patch: PlanoContaPatch) =>
    apiRequest<PlanoConta>(`/v1/financeiro/plano-contas/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(patch),
    }),
  /** DELETE /v1/financeiro/plano-contas/{id} → 204 (soft: ativo=false). Body: { version }. */
  planoContaInativar: (id: string, version: number) =>
    apiRequest<void>(`/v1/financeiro/plano-contas/${id}`, {
      method: 'DELETE',
      body: JSON.stringify({ version }),
    }),

  /** GET /v1/financeiro/centros-custo → sem paginação (envelope { data }). */
  centrosCusto: (params?: CentroCustoListParams) =>
    apiRequest<{ data: CentroCusto[] }>(`/v1/financeiro/centros-custo${paramsToQuery(params)}`),
  /** POST /v1/financeiro/centros-custo → 201 CentroCusto. 422 VALIDATION_ERROR. */
  centroCustoCriar: (input: CentroCustoInput) =>
    apiRequest<CentroCusto>('/v1/financeiro/centros-custo', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** PATCH /v1/financeiro/centros-custo/{id} → 200 CentroCusto. 409 CONFLITO_VERSAO. */
  centroCustoEditar: (id: string, patch: CentroCustoPatch) =>
    apiRequest<CentroCusto>(`/v1/financeiro/centros-custo/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(patch),
    }),
  /** DELETE /v1/financeiro/centros-custo/{id} → 204 (soft: ativo=false). Body: { version }. */
  centroCustoInativar: (id: string, version: number) =>
    apiRequest<void>(`/v1/financeiro/centros-custo/${id}`, {
      method: 'DELETE',
      body: JSON.stringify({ version }),
    }),

  /** GET /v1/financeiro/lancamentos → paginação por cursor (envelope { data, next_cursor }). */
  lancamentos: (params?: LancamentoListParams) =>
    apiRequest<CursorEnvelope<Lancamento>>(`/v1/financeiro/lancamentos${paramsToQuery(params)}`),
  /**
   * POST /v1/financeiro/lancamentos → 201 Lancamento (razão, append-only).
   * Idempotency-Key obrigatória (gerar 1 UUID v4 por submit no chamador).
   */
  lancamentoCriar: (input: LancamentoManualInput, idempotencyKey: string) =>
    apiRequest<Lancamento>('/v1/financeiro/lancamentos', {
      method: 'POST',
      headers: { 'Idempotency-Key': idempotencyKey },
      body: JSON.stringify(input),
    }),

  // ─── Contas a Pagar (WFC-2) ─────────────────────────────────────────────────
  // Leitura: financeiro:ver. Criar fornecedor/OC/contrato: financeiro:configurar
  // (sem MFA). Aprovar/rejeitar OC: financeiro:aprovar (crítica/MFA). Exceção
  // NF-avulsa: financeiro:excecao (crítica/MFA). Registrar pagamento:
  // financeiro:pagar (crítica/MFA + Idempotency-Key). Revelar documento/dados
  // bancários: financeiro:ver_pii (crítica/MFA).

  /** GET /v1/financeiro/fornecedores → sem paginação (envelope { data }). */
  listarFornecedores: (params?: FornecedorListParams) =>
    apiRequest<{ data: Fornecedor[] }>(`/v1/financeiro/fornecedores${paramsToQuery(params)}`),
  /**
   * GET /v1/financeiro/fornecedores COM paginação (F3) — a MESMA rota, que
   * muda de envelope quando `pagina`/`por_pagina` vêm na query:
   * `{ data, total, pagina, por_pagina }`.
   *
   * ⚠️ FUNÇÃO SEPARADA de `listarFornecedores`, de propósito: o envelope é
   * outro, e tipar a antiga como se sempre trouxesse `total` faria toda tela
   * que a usa hoje (seletor de OC, seletor de título) acreditar num número que
   * o servidor não mandou. Medido:
   *
   *     grep -rn "listarFornecedores\b" src --include=*.tsx --include=*.ts \
   *       | grep -v "\.test\." | grep -v domain-api.ts
   *
   * → 8 chamadas: 5 em tela (contratos recorrentes, a lista antiga de
   * fornecedores, lista de OC, nova OC, títulos a pagar) e 3 no serviço
   * `compras-tolerancia-api.ts`. NENHUMA pede página, e todas leem `.data`.
   *
   * `por_pagina` é obrigatório aqui porque é o que liga o modo paginado — sem
   * ele a rota volta ao envelope antigo e `total` chegaria `undefined`.
   */
  listarFornecedoresPagina: (params: FornecedorListParams & { pagina: number; por_pagina: number }) =>
    apiRequest<PaginaFornecedores>(`/v1/financeiro/fornecedores${paramsToQuery(params)}`),
  /** POST /v1/financeiro/fornecedores → 201 Fornecedor (financeiro:configurar). */
  criarFornecedor: (input: FornecedorInput) =>
    apiRequest<Fornecedor>('/v1/financeiro/fornecedores', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /**
   * GET /v1/financeiro/fornecedores/{id} → `{ fornecedor, tem_dados_bancarios,
   * dados_bancarios? }` (documento mascarado; financeiro:ver).
   *
   * ⚠️ A FORMA MUDOU NA F2 (14/10/2026): era o `Fornecedor` cru, passou a ser
   * envelope com o bloco bancário MASCARADO. Mudar sem janela de compatibilidade
   * foi possível porque esta função não tinha nenhum chamador — medido com
   * `git grep -n "obterFornecedor" -- frontend/src | grep -v domain-api.ts`
   * → vazio. A primeira tela a usá-la é a da F3.
   */
  obterFornecedor: (id: string) => apiRequest<FornecedorDetalhe>(`/v1/financeiro/fornecedores/${id}`),
  /**
   * PATCH /v1/financeiro/fornecedores/{id} (F1) — edição cadastral, inclusive
   * o interruptor `ativo` (inativar/reativar, A1). `financeiro:configurar`,
   * SEM MFA: medido no roteador, a rota passa pelo guard `configurar` e o
   * segundo fator é exigido só na troca de dados bancários.
   *
   * 🔴 O CORPO É O FORMULÁRIO INTEIRO (ver `FornecedorCadastraisInput`):
   * mandar só `{ ativo, version }` APAGARIA nome e inscrições. Quem chama
   * monta o corpo a partir do fornecedor LIDO, mudando só o que quer mudar.
   */
  atualizarCadastraisFornecedor: (id: string, input: FornecedorCadastraisInput) =>
    apiRequest<Fornecedor>(`/v1/financeiro/fornecedores/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    }),
  /**
   * PUT /v1/financeiro/fornecedores/{id}/dados-bancarios (F2) — ação PRÓPRIA e
   * CRÍTICA: troca o destino do dinheiro. Exige `financeiro:configurar` E
   * segundo fator (MFA/aal2); sem o fator responde 403 `MFA_REQUERIDA`.
   * `justificativa` é obrigatória e entra na trilha; a resposta devolve o
   * destino novo MASCARADO, nunca o valor inteiro.
   */
  /**
   * PUT /v1/financeiro/fornecedores/{id}/dados-bancarios — troca o DESTINO DO
   * DINHEIRO (financeiro:configurar + MFA/aal2).
   *
   * ⚠️ A `Idempotency-Key` É PARÂMETRO OBRIGATÓRIO, e NÃO um
   * `idempotencyKey()` gerado aqui dentro, de propósito: aquele helper devolve
   * um UUID NOVO a cada chamada, então um retry do mesmo submit viraria chave
   * nova — segunda troca, segunda trilha, segundo aviso, exatamente o que a
   * idempotência existe para impedir. A chave é "gerada no cliente por
   * SUBMIT" (a mesma convenção que o contrato do pagamento já descreve): quem
   * chama guarda a chave enquanto o usuário insiste no mesmo envio.
   */
  trocarDadosBancariosFornecedor: (
    id: string,
    input: TrocaDadosBancariosInput,
    idempotencyKeyDoSubmit: string,
  ) =>
    apiRequest<TrocaDadosBancariosResposta>(`/v1/financeiro/fornecedores/${id}/dados-bancarios`, {
      method: 'PUT',
      body: JSON.stringify(input),
      headers: { 'Idempotency-Key': idempotencyKeyDoSubmit },
    }),
  /**
   * GET /v1/financeiro/fornecedores/{id}/analytics → documento/dados
   * bancários em claro (financeiro:ver_pii — crítica/MFA). Só chamar sob
   * ação explícita do usuário, nunca no carregamento da lista/detalhe.
   */
  revelarFornecedorPII: (id: string) =>
    apiRequest<FornecedorAnalytics>(`/v1/financeiro/fornecedores/${id}/analytics`),
  /**
   * PATCH /v1/financeiro/fornecedores/{id}/prazo-pagamento (NFSE-9) →
   * Fornecedor atualizado, financeiro:configurar. Concorrência otimista:
   * `patch.version` deve ser o `version` atual do fornecedor — divergente
   * devolve 409 (o consumidor da tela deve recarregar e pedir novo envio).
   */
  atualizarPrazoPagamentoFornecedor: (id: string, patch: FornecedorPrazoPagamentoPatch) =>
    apiRequest<Fornecedor>(`/v1/financeiro/fornecedores/${id}/prazo-pagamento`, {
      method: 'PATCH',
      body: JSON.stringify(patch),
    }),

  /**
   * GET /v1/financeiro/ordens-compra → `{ data, total, pagina, por_pagina }`.
   *
   * Paginação é OPT-IN: sem `pagina`/`por_pagina` a rota devolve tudo, como
   * fazia antes da D1 (medido: o único consumidor chamava sem parâmetro algum).
   * `total` vem sempre, e vale a contagem do FILTRO, não da página.
   */
  listarOrdensCompra: (params?: OrdemCompraListParams) =>
    apiRequest<PaginaOrdensCompra>(`/v1/financeiro/ordens-compra${paramsToQuery(queryDaListaOC(params))}`),
  /** POST /v1/financeiro/ordens-compra → 201 OrdemCompra em rascunho (financeiro:configurar). */
  criarOrdemCompra: (input: OrdemCompraInput) =>
    apiRequest<OrdemCompra>('/v1/financeiro/ordens-compra', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** GET /v1/financeiro/ordens-compra/{id} → OrdemCompra com itens (financeiro:ver). */
  obterOrdemCompra: (id: string) => apiRequest<OrdemCompra>(`/v1/financeiro/ordens-compra/${id}`),
  /**
   * GET .../pdf → o PDF da ordem que vai ao fornecedor (COMP-4 / RF-5,
   * financeiro:ver). Devolve o Blob cru, não JSON.
   *
   * O número impresso é `ordem_compra.numero` — o MESMO que o fornecedor deve
   * carimbar no campo `xPed` da nota. É disso que depende a camada 1 da
   * conciliação (D7); sem ele, tudo vira inferência.
   */
  pdfOrdemCompra: (id: string) => apiRequestBlob(`/v1/financeiro/ordens-compra/${id}/pdf`),
  /**
   * POST .../registrar-envio → grava na trilha que a ordem foi enviada
   * (financeiro:configurar). Enquanto não há transporte de e-mail no backend,
   * quem envia é a pessoa e este registro é o rastro — ver
   * `docs/integracoes/delta-para-producao.md`.
   */
  registrarEnvioOC: (id: string, canal: 'email' | 'whatsapp' | 'outro', destinatario?: string) =>
    apiRequest<{ data: { numero: number; canal: string; aceita_pelo_relay: boolean } }>(
      `/v1/financeiro/ordens-compra/${id}/registrar-envio`,
      { method: 'POST', body: JSON.stringify({ canal, destinatario }) },
    ),
  /** POST .../enviar-aprovacao → 200 OrdemCompra (financeiro:configurar). 409 CONFLICT (version). */
  enviarAprovacaoOC: (id: string, input: OrdemCompraVersionInput) =>
    apiRequest<OrdemCompra>(`/v1/financeiro/ordens-compra/${id}/enviar-aprovacao`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** POST .../aprovar → 200 OrdemCompra (financeiro:aprovar — crítica/MFA). Maker-checker (422). */
  aprovarOC: (id: string, input: OrdemCompraVersionInput) =>
    apiRequest<OrdemCompra>(`/v1/financeiro/ordens-compra/${id}/aprovar`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** POST .../rejeitar → 200 OrdemCompra (financeiro:aprovar — crítica/MFA). */
  rejeitarOC: (id: string, input: OrdemCompraVersionInput) =>
    apiRequest<OrdemCompra>(`/v1/financeiro/ordens-compra/${id}/rejeitar`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  /** GET /v1/financeiro/titulos-pagar → paginado (50/página por padrão). */
  listarTitulosPagar: (params?: TituloPagarListParams) =>
    apiRequest<TituloPagarListResponse>(`/v1/financeiro/titulos-pagar${paramsToQuery(params)}`),
  /**
   * GET .../titulos-pagar/agregados → totalizador (financeiro:ver), MESMOS
   * filtros de listarTitulosPagar (achado 08/09/2026 — segue o filtro ativo).
   */
  agregadosTitulosPagar: (params?: TituloPagarListParams) =>
    apiRequest<TitulosAgregados>(`/v1/financeiro/titulos-pagar/agregados${paramsToQuery(params)}`),
  /**
   * GET .../titulos-pagar/relatorio → CSV/XLSX/PDF (financeiro:ver), MESMOS
   * filtros de listarTitulosPagar/agregadosTitulosPagar (achado 15/09/2026 —
   * relatório padronizado no formato que o financeiro já usa no SGA,
   * agrupado por categoria com subtotal). Blob via BFF, mesmo padrão de
   * boletoPdf — nunca monta o arquivo no browser.
   */
  relatorioTitulosPagar: (params: Omit<TituloPagarListParams, 'pagina' | 'per_page'> & { formato: 'csv' | 'xlsx' | 'pdf' }) =>
    apiRequestBlob(`/v1/financeiro/titulos-pagar/relatorio${paramsToQuery(params)}`),
  /**
   * POST .../reclassificar-lote → 200 {titulos_afetados} (financeiro:
   * configurar). Reclassifica TODOS os títulos de um fornecedor de uma vez
   * (achado 08/09/2026).
   */
  reclassificarTitulosPagarLote: (input: ReclassificarTitulosInput) =>
    apiRequest<{ titulos_afetados: number }>('/v1/financeiro/titulos-pagar/reclassificar-lote', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** GET /v1/financeiro/titulos-pagar/{id} → TituloPagar (financeiro:ver). */
  obterTituloPagar: (id: string) => apiRequest<TituloPagar>(`/v1/financeiro/titulos-pagar/${id}`),
  /**
   * POST .../aprovar-pendente → 200 TituloPagar (financeiro:excecao —
   * crítica/MFA). Reconhece um título nf_avulsa nascido automaticamente do
   * vínculo de NF (pendente_aprovacao → aberto).
   */
  aprovarTituloPendente: (id: string, input: AprovarTituloPendenteInput) =>
    apiRequest<TituloPagar>(`/v1/financeiro/titulos-pagar/${id}/aprovar-pendente`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /**
   * GET .../ordens-compra-candidatas → por que o vínculo automático não casou
   * e com quem o manual casaria (financeiro:ver). LEITURA sem MFA: é a dica
   * que o Financeiro precisa ver na tela antes de decidir.
   */
  candidatasOCDoTitulo: (id: string) =>
    apiRequest<CandidatasOCDoTitulo>(`/v1/financeiro/titulos-pagar/${id}/ordens-compra-candidatas`),
  /**
   * POST .../vincular-oc → 200 TituloPagar (financeiro:excecao — crítica/MFA).
   * Liga um título avulso a uma ordem de compra; escreve `ordem_compra_id` de
   * vazio para a ordem e NUNCA troca de ordem (decisão do dono, 08/10/2026).
   */
  vincularTituloAOC: (id: string, input: VincularTituloAOCInput) =>
    apiRequest<TituloPagar>(`/v1/financeiro/titulos-pagar/${id}/vincular-oc`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /**
   * POST .../aprovar-pendente-lote → 200 {resultados} (financeiro:excecao —
   * crítica/MFA). Aprova vários títulos pendente_aprovacao de uma vez, sem
   * reclassificar plano de contas/centro de custo — placar por item (1
   * título com version desatualizada nunca derruba os demais).
   */
  aprovarTituloPendenteLote: (itens: AprovarTituloPendenteLoteItem[]) =>
    apiRequest<AprovarTituloPendenteLoteResponse>('/v1/financeiro/titulos-pagar/aprovar-pendente-lote', {
      method: 'POST',
      body: JSON.stringify({ itens }),
    }),
  /**
   * GET .../lancamentos-bancarios/excecoes → fila de revisão manual do motor
   * de matching PAGAR (financeiro:ver). status default do backend = 'aberta'.
   * texto/nf_numero filtram (achado 07/09/2026); cursor pagina por keyset —
   * reenviar o next_cursor da resposta anterior.
   */
  listarExcecoesConciliacaoPagar: (params?: ExcecaoListParams) =>
    apiRequest<ExcecaoListResponse>(`/v1/financeiro/lancamentos-bancarios/excecoes${paramsToQuery(params)}`),
  /**
   * POST .../excecoes/{id}/resolver → 200 ExcecaoConciliacaoPagar
   * (financeiro:excecao — crítica/MFA). Escolher título = baixa real
   * (Idempotency-Key obrigatória); descartar = justificativa obrigatória.
   */
  resolverExcecaoConciliacaoPagar: (id: string, input: ResolverExcecaoConciliacaoPagarInput) =>
    apiRequest<ExcecaoConciliacaoPagar>(`/v1/financeiro/lancamentos-bancarios/excecoes/${id}/resolver`, {
      method: 'POST',
      ...(input.descartar ? {} : { headers: { 'Idempotency-Key': idempotencyKey() } }),
      body: JSON.stringify(input),
    }),
  /** GET .../nota-fiscal → detalhe rico da NF-e vinculada (financeiro:ver). */
  obterDetalheNFeDoTitulo: (id: string) =>
    apiRequest<DetalheNFeTitulo>(`/v1/financeiro/titulos-pagar/${id}/nota-fiscal`),
  /**
   * POST /v1/financeiro/titulos-pagar/excecao-nf-avulsa → 201 TituloPagar
   * (financeiro:excecao — crítica/MFA). O principal autenticado é o
   * aprovador; 422 se solicitado_por == usuário autenticado (maker-checker).
   */
  criarTituloExcecaoNFAvulsa: (input: TituloExcecaoNFAvulsaInput) =>
    apiRequest<TituloPagar>('/v1/financeiro/titulos-pagar/excecao-nf-avulsa', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** GET .../pagamentos → histórico de liquidações do título (financeiro:ver). */
  listarPagamentosDoTitulo: (tituloId: string) =>
    apiRequest<{ data: Pagamento[] }>(`/v1/financeiro/titulos-pagar/${tituloId}/pagamentos`),
  /**
   * POST .../pagamentos → 201 Pagamento (financeiro:pagar — crítica/MFA).
   * Idempotency-Key obrigatória; aceita pagamento parcial. lancamento_id na
   * resposta é a prova de que postou no razão.
   */
  registrarPagamento: (tituloId: string, input: PagamentoInput) =>
    apiRequest<Pagamento>(`/v1/financeiro/titulos-pagar/${tituloId}/pagamentos`, {
      method: 'POST',
      headers: { 'Idempotency-Key': idempotencyKey() },
      body: JSON.stringify(input),
    }),
  /**
   * POST /v1/contaspagar/extrato/importar-ofx → 200
   * ResultadoImportacaoExtratoOFX (financeiro:configurar). Importação manual
   * do extrato da conta (arquivo .ofx, ex.: "Gerar OFX" no Internet Banking
   * da Sicredi) — atalho enquanto a API de Extrato (mTLS próprio) não tem
   * credencial. arquivoBase64 é o conteúdo cru do arquivo, sem prefixo data
   * URI (mesma convenção do upload de logo do tenant).
   */
  importarExtratoOFX: (arquivoBase64: string) =>
    apiRequest<ResultadoImportacaoExtratoOFX>('/v1/contaspagar/extrato/importar-ofx', {
      method: 'POST',
      body: JSON.stringify({ arquivo_base64: arquivoBase64 }),
    }),
  /**
   * POST .../preview-ofx → só leitura (não grava nada) — mostra o que SERIA
   * processado antes do usuário confirmar (financeiro:configurar, mesmo
   * guard do import real).
   */
  previsualizarExtratoOFX: (arquivoBase64: string) =>
    apiRequest<PreviewImportacaoExtratoOFX>('/v1/contaspagar/extrato/preview-ofx', {
      method: 'POST',
      body: JSON.stringify({ arquivo_base64: arquivoBase64 }),
    }),

  /** GET /v1/financeiro/contratos-recorrentes → sem paginação (envelope { data }). */
  listarContratosRecorrentes: (params?: ContratoRecorrenteListParams) =>
    apiRequest<{ data: ContratoRecorrente[] }>(`/v1/financeiro/contratos-recorrentes${paramsToQuery(params)}`),
  /** POST /v1/financeiro/contratos-recorrentes → 201 ContratoRecorrente (financeiro:configurar). */
  criarContratoRecorrente: (input: ContratoRecorrenteInput) =>
    apiRequest<ContratoRecorrente>('/v1/financeiro/contratos-recorrentes', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /**
   * POST .../contratos-recorrentes/{id}/aprovar → 200 ContratoRecorrente.
   *
   * CR-1: ação CRÍTICA sob `financeiro:aprovar` + MFA — a mesma chave que
   * aprova título por exceção. Quem PROPÔS o contrato não pode aprová-lo (422
   * ErrMakerChecker), sem exceção de admin.
   */
  aprovarContratoRecorrente: (contratoId: string, input: AprovarContratoRecorrenteInput) =>
    apiRequest<ContratoRecorrente>(`/v1/financeiro/contratos-recorrentes/${contratoId}/aprovar`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /**
   * POST .../contratos-recorrentes/{id}/rejeitar → 200 ContratoRecorrente.
   *
   * Quem propôs PODE rejeitar o próprio contrato: rejeitar não libera
   * dinheiro. Quem rejeitou fica na trilha.
   */
  rejeitarContratoRecorrente: (contratoId: string, version: number) =>
    apiRequest<ContratoRecorrente>(`/v1/financeiro/contratos-recorrentes/${contratoId}/rejeitar`, {
      method: 'POST',
      body: JSON.stringify({ version }),
    }),
  /**
   * POST .../confirmar-fatura → 201 TituloPagar (origem_tipo=recorrente;
   * financeiro:configurar).
   *
   * ⚠️ Recusa com 422 enquanto o contrato não estiver APROVADO (CR-1).
   */
  confirmarFaturaContrato: (contratoId: string, input: ConfirmarFaturaInput) =>
    apiRequest<TituloPagar>(`/v1/financeiro/contratos-recorrentes/${contratoId}/confirmar-fatura`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  /**
   * POST /v1/financeiro/conciliacao-bancaria/executar → dispara o pull
   * `liquidados/dia` da Sicredi AGORA, sem esperar a janela do runner
   * (financeiro:baixar — crítica/MFA).
   *
   * Corpo vazio = concilia hoje. `diasRetroativos` cobre "o webhook ficou
   * fora do ar ontem". Reprocessar o mesmo dia é seguro: boleto já pago vira
   * `jaPagos`, nunca uma segunda baixa.
   */
  conciliarBancoAgora: (input?: { dia?: string; diasRetroativos?: number }) =>
    apiRequest<ConciliacaoBancariaResultado>('/v1/financeiro/conciliacao-bancaria/executar', {
      method: 'POST',
      body: JSON.stringify({
        dia: input?.dia ?? '',
        dias_retroativos: input?.diasRetroativos ?? 0,
      }),
    }),

  /**
   * GET /v1/financeiro/conciliacao-bancaria/saude → monitoramento (read-only) do
   * webhook de conciliação: contadores do inbox + estado da flag de runtime
   * (banco:ver_status). Só observabilidade — não toca dinheiro. 404 = conciliação
   * não montada (FEATURE_CONCILIACAO_BANCARIA off).
   */
  saudeConciliacaoBancaria: () =>
    apiRequest<SaudeConciliacaoBancaria>('/v1/financeiro/conciliacao-bancaria/saude'),

  // ─── Integrações Bancárias (frente bancária; atrás de FEATURE_INTEGRACAO_BANCARIA) ─
  /** GET /v1/integracoes-bancarias → contas (mascaradas) do tenant (banco:listar). */
  integracoesBancarias: () =>
    apiRequest<{ contas: ContaBancariaView[] | null }>('/v1/integracoes-bancarias'),
  /** POST /v1/integracoes-bancarias → cria conta cifrada (banco:configurar — crítica/MFA). */
  criarContaBancaria: (input: ContaBancariaInput) =>
    apiRequest<ContaBancariaView>('/v1/integracoes-bancarias', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** PUT /v1/integracoes-bancarias/{id} → edita (credencial vazia = manter). banco:configurar. */
  editarContaBancaria: (id: string, input: ContaBancariaInput) =>
    apiRequest<ContaBancariaView>(`/v1/integracoes-bancarias/${id}`, {
      method: 'PUT',
      body: JSON.stringify(input),
    }),
  /** POST .../{id}/ativar → ativa a conta (uma ativa por banco/ambiente). banco:configurar. */
  ativarContaBancaria: (id: string) =>
    apiRequest<ContaBancariaView>(`/v1/integracoes-bancarias/${id}/ativar`, { method: 'POST' }),
  /** POST .../{id}/desativar → desativa. banco:configurar. */
  desativarContaBancaria: (id: string) =>
    apiRequest<ContaBancariaView>(`/v1/integracoes-bancarias/${id}/desativar`, { method: 'POST' }),
  /** POST /v1/integracoes-bancarias/testar → round-trip de auth (banco:ver_status — crítica/MFA). */
  testarConexaoBancaria: (input: TestarConexaoBancoInput) =>
    apiRequest<ResultadoTesteConexao>('/v1/integracoes-bancarias/testar', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** F4: POST .../{id}/webhook-token → gera/ROTACIONA o token do webhook (banco:configurar — crítica/MFA). */
  gerarWebhookTokenBancario: (id: string) =>
    apiRequest<WebhookTokenView>(`/v1/integracoes-bancarias/${id}/webhook-token`, { method: 'POST' }),
  /**
   * GET /v1/veiculos/{id}/consulta-veicular → última consulta GRAVADA (#584).
   *
   * Lê o nosso banco: não chama a origem e NÃO tem custo. É esta a leitura que
   * a ficha do bem faz ao abrir — disparar consulta nova é o POST, sempre por
   * clique, porque abrir ficha não pode gastar crédito sozinho.
   *
   * `undefined` quando o bem nunca foi consultado (204).
   */
  ultimaConsultaVeicular: (bemID: string) =>
    apiRequest<ConsultaVeicularView | undefined>(`/v1/veiculos/${bemID}/consulta-veicular`),
  /** POST /v1/veiculos/{id}/consulta-veicular → dispara consulta e GRAVA (consulta_veicular:consultar). Tem custo. */
  consultarVeicular: (bemID: string, input: { base_legal: string; finalidade_consulta?: string }) =>
    apiRequest<ConsultaVeicularView>(`/v1/veiculos/${bemID}/consulta-veicular`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
}
